import wife_1_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/lieu-nha-tich.png';
import wife_1_thumbnail from '../images/characters/pc/wife/thumbnail/lieu-nha-tich.png';
import wife_1_detail_mobile from '../images/characters/mobile/wife/detail/lieu-nha-tich.png';
import wife_1_detail from '../images/characters/pc/wife/detail/lieu-nha-tich.png';
import wife_2_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/song-nhi.png';
import wife_2_thumbnail from '../images/characters/pc/wife/thumbnail/song-nhi.png';
import wife_2_detail_mobile from '../images/characters/mobile/wife/detail/song-nhi.png';
import wife_2_detail from '../images/characters/pc/wife/detail/song-nhi.png';
import wife_3_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/thuong-quan-uyen-nhi.png';
import wife_3_thumbnail from '../images/characters/pc/wife/thumbnail/thuong-quan-uyen-nhi.png';
import wife_3_detail_mobile from '../images/characters/mobile/wife/detail/thuong-quan-uyen-nhi.png';
import wife_3_detail from '../images/characters/pc/wife/detail/thuong-quan-uyen-nhi.png';
import wife_4_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/tan-uyen-nhu.png';
import wife_4_thumbnail from '../images/characters/pc/wife/thumbnail/tan-uyen-nhu.png';
import wife_4_detail_mobile from '../images/characters/mobile/wife/detail/tan-uyen-nhu.png';
import wife_4_detail from '../images/characters/pc/wife/detail/tan-uyen-nhu.png';
import wife_5_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/to-tieu-tieu.png';
import wife_5_thumbnail from '../images/characters/pc/wife/thumbnail/to-tieu-tieu.png';
import wife_5_detail_mobile from '../images/characters/mobile/wife/detail/to-tieu-tieu.png';
import wife_5_detail from '../images/characters/pc/wife/detail/to-tieu-tieu.png';
import wife_6_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/muoi-hi.png';
import wife_6_thumbnail from '../images/characters/pc/wife/thumbnail/muoi-hi.png';
import wife_6_detail_mobile from '../images/characters/mobile/wife/detail/muoi-hi.png';
import wife_6_detail from '../images/characters/pc/wife/detail/muoi-hi.png';
import wife_7_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/di-thap-tam.png';
import wife_7_thumbnail from '../images/characters/pc/wife/thumbnail/di-thap-tam.png';
import wife_7_detail_mobile from '../images/characters/mobile/wife/detail/di-thap-tam.png';
import wife_7_detail from '../images/characters/pc/wife/detail/di-thap-tam.png';
import wife_8_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/lang-tieu-tieu.png';
import wife_8_thumbnail from '../images/characters/pc/wife/thumbnail/lang-tieu-tieu.png';
import wife_8_detail_mobile from '../images/characters/mobile/wife/detail/lang-tieu-tieu.png';
import wife_8_detail from '../images/characters/pc/wife/detail/lang-tieu-tieu.png';
import wife_9_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/chan-co.png';
import wife_9_thumbnail from '../images/characters/pc/wife/thumbnail/chan-co.png';
import wife_9_detail_mobile from '../images/characters/mobile/wife/detail/chan-co.png';
import wife_9_detail from '../images/characters/pc/wife/detail/chan-co.png';
import wife_10_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/tieu-chieu.png';
import wife_10_thumbnail from '../images/characters/pc/wife/thumbnail/tieu-chieu.png';
import wife_10_detail_mobile from '../images/characters/mobile/wife/detail/tieu-chieu.png';
import wife_10_detail from '../images/characters/pc/wife/detail/tieu-chieu.png';
import wife_11_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ngu-au-vi.png';
import wife_11_thumbnail from '../images/characters/pc/wife/thumbnail/ngu-au-vi.png';
import wife_11_detail_mobile from '../images/characters/mobile/wife/detail/ngu-au-vi.png';
import wife_11_detail from '../images/characters/pc/wife/detail/ngu-au-vi.png';
import wife_12_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/do-thu-nuong.png';
import wife_12_thumbnail from '../images/characters/pc/wife/thumbnail/do-thu-nuong.png';
import wife_12_detail_mobile from '../images/characters/mobile/wife/detail/do-thu-nuong.png';
import wife_12_detail from '../images/characters/pc/wife/detail/do-thu-nuong.png';
import wife_13_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/bien-ngoc-kinh.png';
import wife_13_thumbnail from '../images/characters/pc/wife/thumbnail/bien-ngoc-kinh.png';
import wife_13_detail_mobile from '../images/characters/mobile/wife/detail/bien-ngoc-kinh.png';
import wife_13_detail from '../images/characters/pc/wife/detail/bien-ngoc-kinh.png';
import wife_14_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/trieu-phi-yen.png';
import wife_14_thumbnail from '../images/characters/pc/wife/thumbnail/trieu-phi-yen.png';
import wife_14_detail_mobile from '../images/characters/mobile/wife/detail/trieu-phi-yen.png';
import wife_14_detail from '../images/characters/pc/wife/detail/trieu-phi-yen.png';
import wife_15_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ly-co.png';
import wife_15_thumbnail from '../images/characters/pc/wife/thumbnail/ly-co.png';
import wife_15_detail_mobile from '../images/characters/mobile/wife/detail/ly-co.png';
import wife_15_detail from '../images/characters/pc/wife/detail/ly-co.png';
import wife_16_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/nhu-suong.png';
import wife_16_thumbnail from '../images/characters/pc/wife/thumbnail/nhu-suong.png';
import wife_16_detail_mobile from '../images/characters/mobile/wife/detail/nhu-suong.png';
import wife_16_detail from '../images/characters/pc/wife/detail/nhu-suong.png';
import wife_17_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/thai-van-co.png';
import wife_17_thumbnail from '../images/characters/pc/wife/thumbnail/thai-van-co.png';
import wife_17_detail_mobile from '../images/characters/mobile/wife/detail/thai-van-co.png';
import wife_17_detail from '../images/characters/pc/wife/detail/thai-van-co.png';
import wife_18_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/bao-tu.png';
import wife_18_thumbnail from '../images/characters/pc/wife/thumbnail/bao-tu.png';
import wife_18_detail_mobile from '../images/characters/mobile/wife/detail/bao-tu.png';
import wife_18_detail from '../images/characters/pc/wife/detail/bao-tu.png';
import wife_19_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/vo-mi-nuong.png';
import wife_19_thumbnail from '../images/characters/pc/wife/thumbnail/vo-mi-nuong.png';
import wife_19_detail_mobile from '../images/characters/mobile/wife/detail/vo-mi-nuong.png';
import wife_19_detail from '../images/characters/pc/wife/detail/vo-mi-nuong.png';
import wife_20_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/vuong-chieu-quan.png';
import wife_20_thumbnail from '../images/characters/pc/wife/thumbnail/vuong-chieu-quan.png';
import wife_20_detail_mobile from '../images/characters/mobile/wife/detail/vuong-chieu-quan.png';
import wife_20_detail from '../images/characters/pc/wife/detail/vuong-chieu-quan.png';
import wife_21_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/duong-ngoc-hoan.png';
import wife_21_thumbnail from '../images/characters/pc/wife/thumbnail/duong-ngoc-hoan.png';
import wife_21_detail_mobile from '../images/characters/mobile/wife/detail/duong-ngoc-hoan.png';
import wife_21_detail from '../images/characters/pc/wife/detail/duong-ngoc-hoan.png';
import wife_22_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/dieu-thuyen.png';
import wife_22_thumbnail from '../images/characters/pc/wife/thumbnail/dieu-thuyen.png';
import wife_22_detail_mobile from '../images/characters/mobile/wife/detail/dieu-thuyen.png';
import wife_22_detail from '../images/characters/pc/wife/detail/dieu-thuyen.png';
import wife_23_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/tay-thi.png';
import wife_23_thumbnail from '../images/characters/pc/wife/thumbnail/tay-thi.png';
import wife_23_detail_mobile from '../images/characters/mobile/wife/detail/tay-thi.png';
import wife_23_detail from '../images/characters/pc/wife/detail/tay-thi.png';
import wife_24_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/dai-kieu.png';
import wife_24_thumbnail from '../images/characters/pc/wife/thumbnail/dai-kieu.png';
import wife_24_detail_mobile from '../images/characters/mobile/wife/detail/dai-kieu.png';
import wife_24_detail from '../images/characters/pc/wife/detail/dai-kieu.png';
import wife_25_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ve-tu-phu.png';
import wife_25_thumbnail from '../images/characters/pc/wife/thumbnail/ve-tu-phu.png';
import wife_25_detail_mobile from '../images/characters/mobile/wife/detail/ve-tu-phu.png';
import wife_25_detail from '../images/characters/pc/wife/detail/ve-tu-phu.png';
import wife_26_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/lam-thi-am.png';
import wife_26_thumbnail from '../images/characters/pc/wife/thumbnail/lam-thi-am.png';
import wife_26_detail_mobile from '../images/characters/mobile/wife/detail/lam-thi-am.png';
import wife_26_detail from '../images/characters/pc/wife/detail/lam-thi-am.png';
import wife_27_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ton-thuong-huong.png';
import wife_27_thumbnail from '../images/characters/pc/wife/thumbnail/ton-thuong-huong.png';
import wife_27_detail_mobile from '../images/characters/mobile/wife/detail/ton-thuong-huong.png';
import wife_27_detail from '../images/characters/pc/wife/detail/ton-thuong-huong.png';
import wife_28_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/co-hoanh-ba.png';
import wife_28_thumbnail from '../images/characters/pc/wife/thumbnail/co-hoanh-ba.png';
import wife_28_detail_mobile from '../images/characters/mobile/wife/detail/co-hoanh-ba.png';
import wife_28_detail from '../images/characters/pc/wife/detail/co-hoanh-ba.png';
import wife_29_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/quan-ngan-binh.png';
import wife_29_thumbnail from '../images/characters/pc/wife/thumbnail/quan-ngan-binh.png';
import wife_29_detail_mobile from '../images/characters/mobile/wife/detail/quan-ngan-binh.png';
import wife_29_detail from '../images/characters/pc/wife/detail/quan-ngan-binh.png';
import wife_30_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/thu-huong.png';
import wife_30_thumbnail from '../images/characters/pc/wife/thumbnail/thu-huong.png';
import wife_30_detail_mobile from '../images/characters/mobile/wife/detail/thu-huong.png';
import wife_30_detail from '../images/characters/pc/wife/detail/thu-huong.png';
import wife_31_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/lu-linh-khoi.png';
import wife_31_thumbnail from '../images/characters/pc/wife/thumbnail/lu-linh-khoi.png';
import wife_31_detail_mobile from '../images/characters/mobile/wife/detail/lu-linh-khoi.png';
import wife_31_detail from '../images/characters/pc/wife/detail/lu-linh-khoi.png';
import wife_32_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/chan-mat.png';
import wife_32_thumbnail from '../images/characters/pc/wife/thumbnail/chan-mat.png';
import wife_32_detail_mobile from '../images/characters/mobile/wife/detail/chan-mat.png';
import wife_32_detail from '../images/characters/pc/wife/detail/chan-mat.png';
import wife_33_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ma-van-loc.png';
import wife_33_thumbnail from '../images/characters/pc/wife/thumbnail/ma-van-loc.png';
import wife_33_detail_mobile from '../images/characters/mobile/wife/detail/ma-van-loc.png';
import wife_33_detail from '../images/characters/pc/wife/detail/ma-van-loc.png';
import wife_34_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/truong-ton-vo-cau.png';
import wife_34_thumbnail from '../images/characters/pc/wife/thumbnail/truong-ton-vo-cau.png';
import wife_34_detail_mobile from '../images/characters/mobile/wife/detail/truong-ton-vo-cau.png';
import wife_34_detail from '../images/characters/pc/wife/detail/truong-ton-vo-cau.png';
import wife_35_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ham-huong-cong-chua.png';
import wife_35_thumbnail from '../images/characters/pc/wife/thumbnail/ham-huong-cong-chua.png';
import wife_35_detail_mobile from '../images/characters/mobile/wife/detail/ham-huong-cong-chua.png';
import wife_35_detail from '../images/characters/pc/wife/detail/ham-huong-cong-chua.png';
import wife_36_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/truong-tinh-thai.png';
import wife_36_thumbnail from '../images/characters/pc/wife/thumbnail/truong-tinh-thai.png';
import wife_36_detail_mobile from '../images/characters/mobile/wife/detail/truong-tinh-thai.png';
import wife_36_detail from '../images/characters/pc/wife/detail/truong-tinh-thai.png';
import wife_37_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/vuong-di.png';
import wife_37_thumbnail from '../images/characters/pc/wife/thumbnail/vuong-di.png';
import wife_37_detail_mobile from '../images/characters/mobile/wife/detail/vuong-di.png';
import wife_37_detail from '../images/characters/pc/wife/detail/vuong-di.png';
import wife_38_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ly-huong-quan.png';
import wife_38_thumbnail from '../images/characters/pc/wife/thumbnail/ly-huong-quan.png';
import wife_38_detail_mobile from '../images/characters/mobile/wife/detail/ly-huong-quan.png';
import wife_38_detail from '../images/characters/pc/wife/detail/ly-huong-quan.png';
import wife_39_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ma-tuong-lan.png';
import wife_39_thumbnail from '../images/characters/pc/wife/thumbnail/ma-tuong-lan.png';
import wife_39_detail_mobile from '../images/characters/mobile/wife/detail/ma-tuong-lan.png';
import wife_39_detail from '../images/characters/pc/wife/detail/ma-tuong-lan.png';
import wife_40_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/dac-ky.png';
import wife_40_thumbnail from '../images/characters/pc/wife/thumbnail/dac-ky.png';
import wife_40_detail_mobile from '../images/characters/mobile/wife/detail/dac-ky.png';
import wife_40_detail from '../images/characters/pc/wife/detail/dac-ky.png';
import wife_41_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/thai-diem.png';
import wife_41_thumbnail from '../images/characters/pc/wife/thumbnail/thai-diem.png';
import wife_41_detail_mobile from '../images/characters/mobile/wife/detail/thai-diem.png';
import wife_41_detail from '../images/characters/pc/wife/detail/thai-diem.png';
import wife_44_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/truong-xuan-hoa.png';
import wife_44_thumbnail from '../images/characters/pc/wife/thumbnail/truong-xuan-hoa.png';
import wife_44_detail_mobile from '../images/characters/mobile/wife/detail/truong-xuan-hoa.png';
import wife_44_detail from '../images/characters/pc/wife/detail/truong-xuan-hoa.png';
import wife_45_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/ha-kim-thien.png';
import wife_45_thumbnail from '../images/characters/pc/wife/thumbnail/ha-kim-thien.png';
import wife_45_detail_mobile from '../images/characters/mobile/wife/detail/ha-kim-thien.png';
import wife_45_detail from '../images/characters/pc/wife/detail/ha-kim-thien.png';
import wife_46_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/chuc-dung.png';
import wife_46_thumbnail from '../images/characters/pc/wife/thumbnail/chuc-dung.png';
import wife_46_detail_mobile from '../images/characters/mobile/wife/detail/chuc-dung.png';
import wife_46_detail from '../images/characters/pc/wife/detail/chuc-dung.png';
import wife_47_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/mao-tuong.png';
import wife_47_thumbnail from '../images/characters/pc/wife/thumbnail/mao-tuong.png';
import wife_47_detail_mobile from '../images/characters/mobile/wife/detail/mao-tuong.png';
import wife_47_detail from '../images/characters/pc/wife/detail/mao-tuong.png';
import wife_48_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/trieu-hop-duc.png';
import wife_48_thumbnail from '../images/characters/pc/wife/thumbnail/trieu-hop-duc.png';
import wife_48_detail_mobile from '../images/characters/mobile/wife/detail/trieu-hop-duc.png';
import wife_48_detail from '../images/characters/pc/wife/detail/trieu-hop-duc.png';
import wife_53_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/binh-duong-cong-chua.png';
import wife_53_thumbnail from '../images/characters/pc/wife/thumbnail/binh-duong-cong-chua.png';
import wife_53_detail_mobile from '../images/characters/mobile/wife/detail/binh-duong-cong-chua.png';
import wife_53_detail from '../images/characters/pc/wife/detail/binh-duong-cong-chua.png';
import wife_56_thumbnail_mobile from '../images/characters/mobile/wife/thumbnail/hoa-moc-lan.png';
import wife_56_thumbnail from '../images/characters/pc/wife/thumbnail/hoa-moc-lan.png';
import wife_56_detail_mobile from '../images/characters/mobile/wife/detail/hoa-moc-lan.png';
import wife_56_detail from '../images/characters/pc/wife/detail/hoa-moc-lan.png';
import hero_1_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/linh-linh-phat.png';
import hero_1_thumbnail from '../images/characters/pc/hero/thumbnail/linh-linh-phat.png';
import hero_1_detail_mobile from '../images/characters/mobile/hero/detail/linh-linh-phat.png';
import hero_1_detail from '../images/characters/pc/hero/detail/linh-linh-phat.png';
import hero_2_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ngao-bai.png';
import hero_2_thumbnail from '../images/characters/pc/hero/thumbnail/ngao-bai.png';
import hero_2_detail_mobile from '../images/characters/mobile/hero/detail/ngao-bai.png';
import hero_2_detail from '../images/characters/pc/hero/detail/ngao-bai.png';
import hero_3_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hoa-than.png';
import hero_3_thumbnail from '../images/characters/pc/hero/thumbnail/hoa-than.png';
import hero_3_detail_mobile from '../images/characters/mobile/hero/detail/hoa-than.png';
import hero_3_detail from '../images/characters/pc/hero/detail/hoa-than.png';
import hero_4_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/trinh-ban-kieu.png';
import hero_4_thumbnail from '../images/characters/pc/hero/thumbnail/trinh-ban-kieu.png';
import hero_4_detail_mobile from '../images/characters/mobile/hero/detail/trinh-ban-kieu.png';
import hero_4_detail from '../images/characters/pc/hero/detail/trinh-ban-kieu.png';
import hero_5_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hi-lai-lac.png';
import hero_5_thumbnail from '../images/characters/pc/hero/thumbnail/hi-lai-lac.png';
import hero_5_detail_mobile from '../images/characters/mobile/hero/detail/hi-lai-lac.png';
import hero_5_detail from '../images/characters/pc/hero/detail/hi-lai-lac.png';
import hero_6_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/to-khat-nhi.png';
import hero_6_thumbnail from '../images/characters/pc/hero/thumbnail/to-khat-nhi.png';
import hero_6_detail_mobile from '../images/characters/mobile/hero/detail/to-khat-nhi.png';
import hero_6_detail from '../images/characters/pc/hero/detail/to-khat-nhi.png';
import hero_7_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ly-ve.png';
import hero_7_thumbnail from '../images/characters/pc/hero/thumbnail/ly-ve.png';
import hero_7_detail_mobile from '../images/characters/mobile/hero/detail/ly-ve.png';
import hero_7_detail from '../images/characters/pc/hero/detail/ly-ve.png';
import hero_8_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/luu-ba-on.png';
import hero_8_thumbnail from '../images/characters/pc/hero/thumbnail/luu-ba-on.png';
import hero_8_detail_mobile from '../images/characters/mobile/hero/detail/luu-ba-on.png';
import hero_8_detail from '../images/characters/pc/hero/detail/luu-ba-on.png';
import hero_9_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/lam-tac-tu.png';
import hero_9_thumbnail from '../images/characters/pc/hero/thumbnail/lam-tac-tu.png';
import hero_9_detail_mobile from '../images/characters/mobile/hero/detail/lam-tac-tu.png';
import hero_9_detail from '../images/characters/pc/hero/detail/lam-tac-tu.png';
import hero_10_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/phuong-the-ngoc.png';
import hero_10_thumbnail from '../images/characters/pc/hero/thumbnail/phuong-the-ngoc.png';
import hero_10_detail_mobile from '../images/characters/mobile/hero/detail/phuong-the-ngoc.png';
import hero_10_detail from '../images/characters/pc/hero/detail/phuong-the-ngoc.png';
import hero_11_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/da-nhi-con.png';
import hero_11_thumbnail from '../images/characters/pc/hero/thumbnail/da-nhi-con.png';
import hero_11_detail_mobile from '../images/characters/mobile/hero/detail/da-nhi-con.png';
import hero_11_detail from '../images/characters/pc/hero/detail/da-nhi-con.png';
import hero_12_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ta-tong-duong.png';
import hero_12_thumbnail from '../images/characters/pc/hero/thumbnail/ta-tong-duong.png';
import hero_12_detail_mobile from '../images/characters/mobile/hero/detail/ta-tong-duong.png';
import hero_12_detail from '../images/characters/pc/hero/detail/ta-tong-duong.png';
import hero_13_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-chi-dong.png';
import hero_13_thumbnail from '../images/characters/pc/hero/thumbnail/truong-chi-dong.png';
import hero_13_detail_mobile from '../images/characters/mobile/hero/detail/truong-chi-dong.png';
import hero_13_detail from '../images/characters/pc/hero/detail/truong-chi-dong.png';
import hero_14_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/bo-tung-linh.png';
import hero_14_thumbnail from '../images/characters/pc/hero/thumbnail/bo-tung-linh.png';
import hero_14_detail_mobile from '../images/characters/mobile/hero/detail/bo-tung-linh.png';
import hero_14_detail from '../images/characters/pc/hero/detail/bo-tung-linh.png';
import hero_15_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ly-hong-chuong.png';
import hero_15_thumbnail from '../images/characters/pc/hero/thumbnail/ly-hong-chuong.png';
import hero_15_detail_mobile from '../images/characters/mobile/hero/detail/ly-hong-chuong.png';
import hero_15_detail from '../images/characters/pc/hero/detail/ly-hong-chuong.png';
import hero_16_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ly-tam-hoan.png';
import hero_16_thumbnail from '../images/characters/pc/hero/thumbnail/ly-tam-hoan.png';
import hero_16_detail_mobile from '../images/characters/mobile/hero/detail/ly-tam-hoan.png';
import hero_16_detail from '../images/characters/pc/hero/detail/ly-tam-hoan.png';
import hero_17_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/sach-ni.png';
import hero_17_thumbnail from '../images/characters/pc/hero/thumbnail/sach-ni.png';
import hero_17_detail_mobile from '../images/characters/mobile/hero/detail/sach-ni.png';
import hero_17_detail from '../images/characters/pc/hero/detail/sach-ni.png';
import hero_18_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ho-tuyet-nham.png';
import hero_18_thumbnail from '../images/characters/pc/hero/thumbnail/ho-tuyet-nham.png';
import hero_18_detail_mobile from '../images/characters/mobile/hero/detail/ho-tuyet-nham.png';
import hero_18_detail from '../images/characters/pc/hero/detail/ho-tuyet-nham.png';
import hero_19_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/tao-tuyet-can.png';
import hero_19_thumbnail from '../images/characters/pc/hero/thumbnail/tao-tuyet-can.png';
import hero_19_detail_mobile from '../images/characters/mobile/hero/detail/tao-tuyet-can.png';
import hero_19_detail from '../images/characters/pc/hero/detail/tao-tuyet-can.png';
import hero_20_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hai-dai-phu.png';
import hero_20_thumbnail from '../images/characters/pc/hero/thumbnail/hai-dai-phu.png';
import hero_20_detail_mobile from '../images/characters/mobile/hero/detail/hai-dai-phu.png';
import hero_20_detail from '../images/characters/pc/hero/detail/hai-dai-phu.png';
import hero_21_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hoa-da.png';
import hero_21_thumbnail from '../images/characters/pc/hero/thumbnail/hoa-da.png';
import hero_21_detail_mobile from '../images/characters/mobile/hero/detail/hoa-da.png';
import hero_21_detail from '../images/characters/pc/hero/detail/hoa-da.png';
import hero_22_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/mac-tu.png';
import hero_22_thumbnail from '../images/characters/pc/hero/thumbnail/mac-tu.png';
import hero_22_detail_mobile from '../images/characters/mobile/hero/detail/mac-tu.png';
import hero_22_detail from '../images/characters/pc/hero/detail/mac-tu.png';
import hero_23_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/do-phu.png';
import hero_23_thumbnail from '../images/characters/pc/hero/thumbnail/do-phu.png';
import hero_23_detail_mobile from '../images/characters/mobile/hero/detail/do-phu.png';
import hero_23_detail from '../images/characters/pc/hero/detail/do-phu.png';
import hero_24_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/liem-pha.png';
import hero_24_thumbnail from '../images/characters/pc/hero/thumbnail/liem-pha.png';
import hero_24_detail_mobile from '../images/characters/mobile/hero/detail/liem-pha.png';
import hero_24_detail from '../images/characters/pc/hero/detail/liem-pha.png';
import hero_25_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/trang-chu.png';
import hero_25_thumbnail from '../images/characters/pc/hero/thumbnail/trang-chu.png';
import hero_25_detail_mobile from '../images/characters/mobile/hero/detail/trang-chu.png';
import hero_25_detail from '../images/characters/pc/hero/detail/trang-chu.png';
import hero_26_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ly-nguyen-phuong.png';
import hero_26_thumbnail from '../images/characters/pc/hero/thumbnail/ly-nguyen-phuong.png';
import hero_26_detail_mobile from '../images/characters/mobile/hero/detail/ly-nguyen-phuong.png';
import hero_26_detail from '../images/characters/pc/hero/detail/ly-nguyen-phuong.png';
import hero_27_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/lo-ban.png';
import hero_27_thumbnail from '../images/characters/pc/hero/thumbnail/lo-ban.png';
import hero_27_detail_mobile from '../images/characters/mobile/hero/detail/lo-ban.png';
import hero_27_detail from '../images/characters/pc/hero/detail/lo-ban.png';
import hero_28_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ton-vu.png';
import hero_28_thumbnail from '../images/characters/pc/hero/thumbnail/ton-vu.png';
import hero_28_detail_mobile from '../images/characters/mobile/hero/detail/ton-vu.png';
import hero_28_detail from '../images/characters/pc/hero/detail/ton-vu.png';
import hero_29_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-luong.png';
import hero_29_thumbnail from '../images/characters/pc/hero/thumbnail/truong-luong.png';
import hero_29_detail_mobile from '../images/characters/mobile/hero/detail/truong-luong.png';
import hero_29_detail from '../images/characters/pc/hero/detail/truong-luong.png';
import hero_30_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/khuong-tu-nha.png';
import hero_30_thumbnail from '../images/characters/pc/hero/thumbnail/khuong-tu-nha.png';
import hero_30_detail_mobile from '../images/characters/mobile/hero/detail/khuong-tu-nha.png';
import hero_30_detail from '../images/characters/pc/hero/detail/khuong-tu-nha.png';
import hero_31_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ton-tan.png';
import hero_31_thumbnail from '../images/characters/pc/hero/thumbnail/ton-tan.png';
import hero_31_detail_mobile from '../images/characters/mobile/hero/detail/ton-tan.png';
import hero_31_detail from '../images/characters/pc/hero/detail/ton-tan.png';
import hero_32_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/bach-khoi.png';
import hero_32_thumbnail from '../images/characters/pc/hero/thumbnail/bach-khoi.png';
import hero_32_detail_mobile from '../images/characters/mobile/hero/detail/bach-khoi.png';
import hero_32_detail from '../images/characters/pc/hero/detail/bach-khoi.png';
import hero_33_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/quan-vu.png';
import hero_33_thumbnail from '../images/characters/pc/hero/thumbnail/quan-vu.png';
import hero_33_detail_mobile from '../images/characters/mobile/hero/detail/quan-vu.png';
import hero_33_detail from '../images/characters/pc/hero/detail/quan-vu.png';
import hero_34_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-phi.png';
import hero_34_thumbnail from '../images/characters/pc/hero/thumbnail/truong-phi.png';
import hero_34_detail_mobile from '../images/characters/mobile/hero/detail/truong-phi.png';
import hero_34_detail from '../images/characters/pc/hero/detail/truong-phi.png';
import hero_35_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/trieu-van.png';
import hero_35_thumbnail from '../images/characters/pc/hero/thumbnail/trieu-van.png';
import hero_35_detail_mobile from '../images/characters/mobile/hero/detail/trieu-van.png';
import hero_35_detail from '../images/characters/pc/hero/detail/trieu-van.png';
import hero_36_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ma-sieu.png';
import hero_36_thumbnail from '../images/characters/pc/hero/thumbnail/ma-sieu.png';
import hero_36_detail_mobile from '../images/characters/mobile/hero/detail/ma-sieu.png';
import hero_36_detail from '../images/characters/pc/hero/detail/ma-sieu.png';
import hero_37_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hoang-trung.png';
import hero_37_thumbnail from '../images/characters/pc/hero/thumbnail/hoang-trung.png';
import hero_37_detail_mobile from '../images/characters/mobile/hero/detail/hoang-trung.png';
import hero_37_detail from '../images/characters/pc/hero/detail/hoang-trung.png';
import hero_38_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/gia-cat-luong.png';
import hero_38_thumbnail from '../images/characters/pc/hero/thumbnail/gia-cat-luong.png';
import hero_38_detail_mobile from '../images/characters/mobile/hero/detail/gia-cat-luong.png';
import hero_38_detail from '../images/characters/pc/hero/detail/gia-cat-luong.png';
import hero_39_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/bang-thong.png';
import hero_39_thumbnail from '../images/characters/pc/hero/thumbnail/bang-thong.png';
import hero_39_detail_mobile from '../images/characters/mobile/hero/detail/bang-thong.png';
import hero_39_detail from '../images/characters/pc/hero/detail/bang-thong.png';
import hero_40_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/chu-du.png';
import hero_40_thumbnail from '../images/characters/pc/hero/thumbnail/chu-du.png';
import hero_40_detail_mobile from '../images/characters/mobile/hero/detail/chu-du.png';
import hero_40_detail from '../images/characters/pc/hero/detail/chu-du.png';
import hero_41_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/quach-gia.png';
import hero_41_thumbnail from '../images/characters/pc/hero/thumbnail/quach-gia.png';
import hero_41_detail_mobile from '../images/characters/mobile/hero/detail/quach-gia.png';
import hero_41_detail from '../images/characters/pc/hero/detail/quach-gia.png';
import hero_42_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hung-no-vuong.png';
import hero_42_thumbnail from '../images/characters/pc/hero/thumbnail/hung-no-vuong.png';
import hero_42_detail_mobile from '../images/characters/mobile/hero/detail/hung-no-vuong.png';
import hero_42_detail from '../images/characters/pc/hero/detail/hung-no-vuong.png';
import hero_43_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/kinh-kha.png';
import hero_43_thumbnail from '../images/characters/pc/hero/thumbnail/kinh-kha.png';
import hero_43_detail_mobile from '../images/characters/mobile/hero/detail/kinh-kha.png';
import hero_43_detail from '../images/characters/pc/hero/detail/kinh-kha.png';
import hero_44_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/vi-tieu-bao.png';
import hero_44_thumbnail from '../images/characters/pc/hero/thumbnail/vi-tieu-bao.png';
import hero_44_detail_mobile from '../images/characters/mobile/hero/detail/vi-tieu-bao.png';
import hero_44_detail from '../images/characters/pc/hero/detail/vi-tieu-bao.png';
import hero_45_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hoang-phi-hong.png';
import hero_45_thumbnail from '../images/characters/pc/hero/thumbnail/hoang-phi-hong.png';
import hero_45_detail_mobile from '../images/characters/mobile/hero/detail/hoang-phi-hong.png';
import hero_45_detail from '../images/characters/pc/hero/detail/hoang-phi-hong.png';
import hero_46_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ly-bach.png';
import hero_46_thumbnail from '../images/characters/pc/hero/thumbnail/ly-bach.png';
import hero_46_detail_mobile from '../images/characters/mobile/hero/detail/ly-bach.png';
import hero_46_detail from '../images/characters/pc/hero/detail/ly-bach.png';
import hero_47_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/lu-bo.png';
import hero_47_thumbnail from '../images/characters/pc/hero/thumbnail/lu-bo.png';
import hero_47_detail_mobile from '../images/characters/mobile/hero/detail/lu-bo.png';
import hero_47_detail from '../images/characters/pc/hero/detail/lu-bo.png';
import hero_48_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ton-sach.png';
import hero_48_thumbnail from '../images/characters/pc/hero/thumbnail/ton-sach.png';
import hero_48_detail_mobile from '../images/characters/mobile/hero/detail/ton-sach.png';
import hero_48_detail from '../images/characters/pc/hero/detail/ton-sach.png';
import hero_49_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/han-vu-de.png';
import hero_49_thumbnail from '../images/characters/pc/hero/thumbnail/han-vu-de.png';
import hero_49_detail_mobile from '../images/characters/mobile/hero/detail/han-vu-de.png';
import hero_49_detail from '../images/characters/pc/hero/detail/han-vu-de.png';
import hero_50_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ton-thuong-huong.png';
import hero_50_thumbnail from '../images/characters/pc/hero/thumbnail/ton-thuong-huong.png';
import hero_50_detail_mobile from '../images/characters/mobile/hero/detail/ton-thuong-huong.png';
import hero_50_detail from '../images/characters/pc/hero/detail/ton-thuong-huong.png';
import hero_51_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/quan-ngan-binh.png';
import hero_51_thumbnail from '../images/characters/pc/hero/thumbnail/quan-ngan-binh.png';
import hero_51_detail_mobile from '../images/characters/mobile/hero/detail/quan-ngan-binh.png';
import hero_51_detail from '../images/characters/pc/hero/detail/quan-ngan-binh.png';
import hero_52_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/duong-ba-ho.png';
import hero_52_thumbnail from '../images/characters/pc/hero/thumbnail/duong-ba-ho.png';
import hero_52_detail_mobile from '../images/characters/mobile/hero/detail/duong-ba-ho.png';
import hero_52_detail from '../images/characters/pc/hero/detail/duong-ba-ho.png';
import hero_53_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/lu-linh-khoi.png';
import hero_53_thumbnail from '../images/characters/pc/hero/thumbnail/lu-linh-khoi.png';
import hero_53_detail_mobile from '../images/characters/mobile/hero/detail/lu-linh-khoi.png';
import hero_53_detail from '../images/characters/pc/hero/detail/lu-linh-khoi.png';
import hero_54_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/tao-phi.png';
import hero_54_thumbnail from '../images/characters/pc/hero/thumbnail/tao-phi.png';
import hero_54_detail_mobile from '../images/characters/mobile/hero/detail/tao-phi.png';
import hero_54_detail from '../images/characters/pc/hero/detail/tao-phi.png';
import hero_55_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ma-van-loc.png';
import hero_55_thumbnail from '../images/characters/pc/hero/thumbnail/ma-van-loc.png';
import hero_55_detail_mobile from '../images/characters/mobile/hero/detail/ma-van-loc.png';
import hero_55_detail from '../images/characters/pc/hero/detail/ma-van-loc.png';
import hero_56_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ly-the-dan.png';
import hero_56_thumbnail from '../images/characters/pc/hero/thumbnail/ly-the-dan.png';
import hero_56_detail_mobile from '../images/characters/mobile/hero/detail/ly-the-dan.png';
import hero_56_detail from '../images/characters/pc/hero/detail/ly-the-dan.png';
import hero_57_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/nhi-dan-vuong-tu.png';
import hero_57_thumbnail from '../images/characters/pc/hero/thumbnail/nhi-dan-vuong-tu.png';
import hero_57_detail_mobile from '../images/characters/mobile/hero/detail/nhi-dan-vuong-tu.png';
import hero_57_detail from '../images/characters/pc/hero/detail/nhi-dan-vuong-tu.png';
import hero_58_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-tinh-thai.png';
import hero_58_thumbnail from '../images/characters/pc/hero/thumbnail/truong-tinh-thai.png';
import hero_58_detail_mobile from '../images/characters/mobile/hero/detail/truong-tinh-thai.png';
import hero_58_detail from '../images/characters/pc/hero/detail/truong-tinh-thai.png';
import hero_59_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-lieu.png';
import hero_59_thumbnail from '../images/characters/pc/hero/thumbnail/truong-lieu.png';
import hero_59_detail_mobile from '../images/characters/mobile/hero/detail/truong-lieu.png';
import hero_59_detail from '../images/characters/pc/hero/detail/truong-lieu.png';
import hero_60_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/nhac-tien.png';
import hero_60_thumbnail from '../images/characters/pc/hero/thumbnail/nhac-tien.png';
import hero_60_detail_mobile from '../images/characters/mobile/hero/detail/nhac-tien.png';
import hero_60_detail from '../images/characters/pc/hero/detail/nhac-tien.png';
import hero_61_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/vu-cam.png';
import hero_61_thumbnail from '../images/characters/pc/hero/thumbnail/vu-cam.png';
import hero_61_detail_mobile from '../images/characters/mobile/hero/detail/vu-cam.png';
import hero_61_detail from '../images/characters/pc/hero/detail/vu-cam.png';
import hero_62_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-hop.png';
import hero_62_thumbnail from '../images/characters/pc/hero/thumbnail/truong-hop.png';
import hero_62_detail_mobile from '../images/characters/mobile/hero/detail/truong-hop.png';
import hero_62_detail from '../images/characters/pc/hero/detail/truong-hop.png';
import hero_63_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/tu-hoang.png';
import hero_63_thumbnail from '../images/characters/pc/hero/thumbnail/tu-hoang.png';
import hero_63_detail_mobile from '../images/characters/mobile/hero/detail/tu-hoang.png';
import hero_63_detail from '../images/characters/pc/hero/detail/tu-hoang.png';
import hero_64_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/mo-kim-hieu-uy.png';
import hero_64_thumbnail from '../images/characters/pc/hero/thumbnail/mo-kim-hieu-uy.png';
import hero_64_detail_mobile from '../images/characters/mobile/hero/detail/mo-kim-hieu-uy.png';
import hero_64_detail from '../images/characters/pc/hero/detail/mo-kim-hieu-uy.png';
import hero_65_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/vuong-di.png';
import hero_65_thumbnail from '../images/characters/pc/hero/thumbnail/vuong-di.png';
import hero_65_detail_mobile from '../images/characters/mobile/hero/detail/vuong-di.png';
import hero_65_detail from '../images/characters/pc/hero/detail/vuong-di.png';
import hero_66_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/truong-xuan-hoa.png';
import hero_66_thumbnail from '../images/characters/pc/hero/thumbnail/truong-xuan-hoa.png';
import hero_66_detail_mobile from '../images/characters/mobile/hero/detail/truong-xuan-hoa.png';
import hero_66_detail from '../images/characters/pc/hero/detail/truong-xuan-hoa.png';
import hero_67_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/trieu-khuong-dan.png';
import hero_67_thumbnail from '../images/characters/pc/hero/thumbnail/trieu-khuong-dan.png';
import hero_67_detail_mobile from '../images/characters/mobile/hero/detail/trieu-khuong-dan.png';
import hero_67_detail from '../images/characters/pc/hero/detail/trieu-khuong-dan.png';
import hero_68_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/chuc-dung.png';
import hero_68_thumbnail from '../images/characters/pc/hero/thumbnail/chuc-dung.png';
import hero_68_detail_mobile from '../images/characters/mobile/hero/detail/chuc-dung.png';
import hero_68_detail from '../images/characters/pc/hero/detail/chuc-dung.png';
import hero_69_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/cao-truong-cung.png';
import hero_69_thumbnail from '../images/characters/pc/hero/thumbnail/cao-truong-cung.png';
import hero_69_detail_mobile from '../images/characters/mobile/hero/detail/cao-truong-cung.png';
import hero_69_detail from '../images/characters/pc/hero/detail/cao-truong-cung.png';
import hero_70_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/duong-dien-chieu.png';
import hero_70_thumbnail from '../images/characters/pc/hero/thumbnail/duong-dien-chieu.png';
import hero_70_detail_mobile from '../images/characters/mobile/hero/detail/duong-dien-chieu.png';
import hero_70_detail from '../images/characters/pc/hero/detail/duong-dien-chieu.png';
import hero_71_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hoac-khu-benh.png';
import hero_71_thumbnail from '../images/characters/pc/hero/thumbnail/hoac-khu-benh.png';
import hero_71_detail_mobile from '../images/characters/mobile/hero/detail/hoac-khu-benh.png';
import hero_71_detail from '../images/characters/pc/hero/detail/hoac-khu-benh.png';
import hero_72_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/luc-ton.png';
import hero_72_thumbnail from '../images/characters/pc/hero/thumbnail/luc-ton.png';
import hero_72_detail_mobile from '../images/characters/mobile/hero/detail/luc-ton.png';
import hero_72_detail from '../images/characters/pc/hero/detail/luc-ton.png';
import hero_75_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/chan-lu-bo.png';
import hero_75_thumbnail from '../images/characters/pc/hero/thumbnail/chan-lu-bo.png';
import hero_75_detail_mobile from '../images/characters/mobile/hero/detail/chan-lu-bo.png';
import hero_75_detail from '../images/characters/pc/hero/detail/chan-lu-bo.png';
import hero_77_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/tu-ma-y.png';
import hero_77_thumbnail from '../images/characters/pc/hero/thumbnail/tu-ma-y.png';
import hero_77_detail_mobile from '../images/characters/mobile/hero/detail/tu-ma-y.png';
import hero_77_detail from '../images/characters/pc/hero/detail/tu-ma-y.png';
import hero_79_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/ve-thanh.png';
import hero_79_thumbnail from '../images/characters/pc/hero/thumbnail/ve-thanh.png';
import hero_79_detail_mobile from '../images/characters/mobile/hero/detail/ve-thanh.png';
import hero_79_detail from '../images/characters/pc/hero/detail/ve-thanh.png';
import hero_82_thumbnail_mobile from '../images/characters/mobile/hero/thumbnail/hoa-moc-lan.png';
import hero_82_thumbnail from '../images/characters/pc/hero/thumbnail/hoa-moc-lan.png';
import hero_82_detail_mobile from '../images/characters/mobile/hero/detail/hoa-moc-lan.png';
import hero_82_detail from '../images/characters/pc/hero/detail/hoa-moc-lan.png';

import box_tuong_than_1 from '../images/characters/speech-box/tuong-than-1.png';
import box_tuong_than_2 from '../images/characters/speech-box/tuong-than-2.png';
import box_my_nhan_1 from '../images/characters/speech-box/my-nhan-1.png';
import box_my_nhan_2 from '../images/characters/speech-box/my-nhan-2.png';
import box_my_nhan_3 from '../images/characters/speech-box/my-nhan-3.png';

export const speechArr = {
  hero: [box_tuong_than_1, box_tuong_than_2],
  wife: [box_my_nhan_1, box_my_nhan_2, box_my_nhan_3],
};

const CharacterData = {
  WIFE: [
    {
      id: 1,
      name: 'Liễu Nhã Tịch',
      desc: `Đại tiểu thư Liễu gia, yểu điệu dịu dàng, học cao hiểu rộng.`,
      thumbnail: {
        mobile: wife_1_thumbnail_mobile,
        pc: wife_1_thumbnail,
      },
      detail: {
        mobile: wife_1_detail_mobile,
        pc: wife_1_detail,
      },
    },
    {
      id: 2,
      name: 'Song Nhi',
      desc: `Mỹ nữ Thiên Địa Hội, ngây thơ đáng yêu, trung can nghĩa đảm, võ nghệ cao cường.`,
      thumbnail: {
        mobile: wife_2_thumbnail_mobile,
        pc: wife_2_thumbnail,
      },
      detail: {
        mobile: wife_2_detail_mobile,
        pc: wife_2_detail,
      },
    },
    {
      id: 3,
      name: 'Thượng Quan Uyển Nhi',
      desc: `Đại mỹ nhân nổi tiếng kinh thành, quan lại quyền quý trong thành đều nhòm ngó.`,
      thumbnail: {
        mobile: wife_3_thumbnail_mobile,
        pc: wife_3_thumbnail,
      },
      detail: {
        mobile: wife_3_detail_mobile,
        pc: wife_3_detail,
      },
    },
    {
      id: 4,
      name: 'Tần Uyển Như',
      desc: `Là thanh mai trúc mã với ngươi từ nhỏ, tri thư đạt lễ, dịu dàng hiền thục.`,
      thumbnail: {
        mobile: wife_4_thumbnail_mobile,
        pc: wife_4_thumbnail,
      },
      detail: {
        mobile: wife_4_detail_mobile,
        pc: wife_4_detail,
      },
      speechBox: box_my_nhan_1,
    },
    {
      id: 5,
      name: 'Tô Tiểu Tiểu',
      desc: `Danh nghệ tuyệt sắc Hạnh Hoa Lâu, giỏi thơ từ.`,
      thumbnail: {
        mobile: wife_5_thumbnail_mobile,
        pc: wife_5_thumbnail,
      },
      detail: {
        mobile: wife_5_detail_mobile,
        pc: wife_5_detail,
      },
    },
    {
      id: 6,
      name: 'Muội Hỉ',
      desc: `Hữu thi mạt hỷ, mi mục thanh hề. Trang nghê thái y, niễu na phi hề. Tinh doanh vũ lộ, nhân chi liên hề`,
      thumbnail: {
        mobile: wife_6_thumbnail_mobile,
        pc: wife_6_thumbnail,
      },
      detail: {
        mobile: wife_6_detail_mobile,
        pc: wife_6_detail,
      },
    },
    {
      id: 7,
      name: 'Dì Thập Tam',
      desc: `Đến từ tây phương, xinh đẹp phóng khoáng, tinh thông ngoại văn, cưỡi ngựa, tư tưởng cởi mở, hành động bạo gan`,
      thumbnail: {
        mobile: wife_7_thumbnail_mobile,
        pc: wife_7_thumbnail,
      },
      detail: {
        mobile: wife_7_detail_mobile,
        pc: wife_7_detail,
      },
    },
    {
      id: 8,
      name: 'Lăng Tiểu Tiểu',
      desc: `Mỹ nữ Thiên Địa Hội, võ nghệ cao cường, ngây thơ lãng mạn, son sắc chung thủy.`,
      thumbnail: {
        mobile: wife_8_thumbnail_mobile,
        pc: wife_8_thumbnail,
      },
      detail: {
        mobile: wife_8_detail_mobile,
        pc: wife_8_detail,
      },
    },
    {
      id: 9,
      name: 'Chân Cơ',
      desc: `Kinh Thành Nữ Y, bẩm sinh thông minh, y thuật cao siêu, là nữ y nổi tiến trong thành.`,
      thumbnail: {
        mobile: wife_9_thumbnail_mobile,
        pc: wife_9_thumbnail,
      },
      detail: {
        mobile: wife_9_detail_mobile,
        pc: wife_9_detail,
      },
      speechBox: box_my_nhan_2,
    },
    {
      id: 10,
      name: 'Tiểu Chiêu',
      desc: `Danh nghệ tuyệt sắc Hạnh Hoa Lâu, có tài có sắc, nổi tiếng khắp nơi, giỏi diễn điệu hát Dực Dương.`,
      thumbnail: {
        mobile: wife_10_thumbnail_mobile,
        pc: wife_10_thumbnail,
      },
      detail: {
        mobile: wife_10_detail_mobile,
        pc: wife_10_detail,
      },
    },
    {
      id: 11,
      name: 'Ngư Ấu Vi',
      desc: `Cầm nữ Hạnh Hoa Lâu, xinh đẹp, chung tình　Khiến người ta thổn thức.`,
      thumbnail: {
        mobile: wife_11_thumbnail_mobile,
        pc: wife_11_thumbnail,
      },
      detail: {
        mobile: wife_11_detail_mobile,
        pc: wife_11_detail,
      },
    },
    {
      id: 12,
      name: 'Đỗ Thu Nương',
      desc: `Ca nữ tuyệt sắc Hạnh Hoa Lâu, cá tính mạnh mẽ, ngay thẳng thông tuệ, đứng đầu Tần Hoài Bát Diễm.`,
      thumbnail: {
        mobile: wife_12_thumbnail_mobile,
        pc: wife_12_thumbnail,
      },
      detail: {
        mobile: wife_12_detail_mobile,
        pc: wife_12_detail,
      },
    },
    {
      id: 13,
      name: 'Biện Ngọc Kinh',
      desc: `Nghệ nữ tuyệt sắc Hạnh Hoa Lâu, tài nghệ xuất chúng, giỏi thi họa, giỏi khảy đàn`,
      thumbnail: {
        mobile: wife_13_thumbnail_mobile,
        pc: wife_13_thumbnail,
      },
      detail: {
        mobile: wife_13_detail_mobile,
        pc: wife_13_detail,
      },
    },
    {
      id: 14,
      name: 'Triệu Phi Yến',
      desc: `Vũ Nữ Oa Quốc, thông minh múa đẹp, được phong làm Tuyệt Thế Vũ Nữ`,
      thumbnail: {
        mobile: wife_14_thumbnail_mobile,
        pc: wife_14_thumbnail,
      },
      detail: {
        mobile: wife_14_detail_mobile,
        pc: wife_14_detail,
      },
    },
    {
      id: 15,
      name: 'Ly Cơ',
      desc: `Phong trần tam hiệp, xinh đẹp dịu dàng, võ công cao cường, là nữ cường nhân nổi tiếng Kinh Thành.`,
      thumbnail: {
        mobile: wife_15_thumbnail_mobile,
        pc: wife_15_thumbnail,
      },
      detail: {
        mobile: wife_15_detail_mobile,
        pc: wife_15_detail,
      },
    },
    {
      id: 16,
      name: 'Như Sương',
      desc: `Tiểu thư Như Gia Trang, hoạt bát tinh nghịch, hiếu học ngây thơ, nữ cải nam trang thì sao chứ.`,
      thumbnail: {
        mobile: wife_16_thumbnail_mobile,
        pc: wife_16_thumbnail,
      },
      detail: {
        mobile: wife_16_detail_mobile,
        pc: wife_16_detail,
      },
      speechBox: box_my_nhan_3,
    },
    {
      id: 17,
      name: 'Thái Văn Cơ',
      desc: `Mi như núi xa, mắt như thu thủy, đẹp như thiên tiên, hoa trước mặt nàng, cũng thấy xấu hổ.`,
      thumbnail: {
        mobile: wife_17_thumbnail_mobile,
        pc: wife_17_thumbnail,
      },
      detail: {
        mobile: wife_17_detail_mobile,
        pc: wife_17_detail,
      },
    },
    {
      id: 18,
      name: 'Bao Tự',
      desc: `Bao Tự không thích cười, nhưng “mặt mày thanh tú, mái tóc đen tuyền, có ung mạo xinh đẹp như hoa, nghiêng nước nghiêng thành”.`,
      thumbnail: {
        mobile: wife_18_thumbnail_mobile,
        pc: wife_18_thumbnail,
      },
      detail: {
        mobile: wife_18_detail_mobile,
        pc: wife_18_detail,
      },
    },
    {
      id: 19,
      name: 'Võ Mị Nương',
      desc: `Nữ hoàng đế đầu tiên trong lịch sử, nhan sắc hơn người, thông minh lanh lợi, học rộng hiểu cao.`,
      thumbnail: {
        mobile: wife_19_thumbnail_mobile,
        pc: wife_19_thumbnail,
      },
      detail: {
        mobile: wife_19_detail_mobile,
        pc: wife_19_detail,
      },
    },
    {
      id: 20,
      name: 'Vương Chiêu Quân',
      desc: `Tao nhã xinh đẹp, tiếng đàn ai oán du dương, được mệnh danh là “Lạc Nhạn”.`,
      thumbnail: {
        mobile: wife_20_thumbnail_mobile,
        pc: wife_20_thumbnail,
      },
      detail: {
        mobile: wife_20_detail_mobile,
        pc: wife_20_detail,
      },
    },
    {
      id: 21,
      name: 'Dương Ngọc Hoàn',
      desc: `Nghiêng nước nghiêng thành, giỏi ca múa, thạo âm luật, được mệnh danh là “Tu Hoa”.`,
      thumbnail: {
        mobile: wife_21_thumbnail_mobile,
        pc: wife_21_thumbnail,
      },
      detail: {
        mobile: wife_21_detail_mobile,
        pc: wife_21_detail,
      },
    },
    {
      id: 22,
      name: 'Điêu Thuyền',
      desc: `Dáng vẻ xinh đẹp, lúc đi như cành liễu trước gió, lúc ngồi vô cùng tao nhã, được mệnh danh là “Bế Nguyệt”.`,
      thumbnail: {
        mobile: wife_22_thumbnail_mobile,
        pc: wife_22_thumbnail,
      },
      detail: {
        mobile: wife_22_detail_mobile,
        pc: wife_22_detail,
      },
    },
    {
      id: 23,
      name: 'Tây Thi',
      desc: `Xinh đẹp như tiên, vóc dáng tuyệt hảo, được mệnh danh là “Trầm Ngư”.`,
      thumbnail: {
        mobile: wife_23_thumbnail_mobile,
        pc: wife_23_thumbnail,
      },
      detail: {
        mobile: wife_23_detail_mobile,
        pc: wife_23_detail,
      },
    },
    {
      id: 24,
      name: 'Đại Kiều',
      desc: `Người Lư Giang Hoản Huyện, là trưởng nữ của Kiều Công, tỷ tỷ của Tiểu Kiều, cùng với Tiểu Kiều được mệnh danh là “Giang Đông Nhị Kiều”, quốc sắc thiên hương.`,
      thumbnail: {
        mobile: wife_24_thumbnail_mobile,
        pc: wife_24_thumbnail,
      },
      detail: {
        mobile: wife_24_detail_mobile,
        pc: wife_24_detail,
      },
    },
    {
      id: 25,
      name: 'Vệ Tử Phu',
      desc: `Thân thế hàn vi, gia hiệu Vệ Thị. Từ nhỏ đã xinh đẹp động lòng.`,
      thumbnail: {
        mobile: wife_25_thumbnail_mobile,
        pc: wife_25_thumbnail,
      },
      detail: {
        mobile: wife_25_detail_mobile,
        pc: wife_25_detail,
      },
    },
    {
      id: 26,
      name: 'Lâm Thi Âm',
      desc: `Xuất thân nhà quan Nam Kinh, trong sáng yêu kiều, thông thạo cầm kỳ thi họa, sở trường Tiểu Khải, thông văn sử.`,
      thumbnail: {
        mobile: wife_26_thumbnail_mobile,
        pc: wife_26_thumbnail,
      },
      detail: {
        mobile: wife_26_detail_mobile,
        pc: wife_26_detail,
      },
    },
    {
      id: 27,
      name: 'Tôn Thượng Hương',
      desc: `Muội muội của Đông Ngô Tôn Quyền, quốc sắc thiên hương, dung nhan diễm lệ, võ nghệ bất phàm.`,
      thumbnail: {
        mobile: wife_27_thumbnail_mobile,
        pc: wife_27_thumbnail,
      },
      detail: {
        mobile: wife_27_detail_mobile,
        pc: wife_27_detail,
      },
    },
    {
      id: 28,
      name: 'Cố Hoành Ba',
      desc: `Khéo tay, giỏi âm luật, sở trường vẽ hoa lan, hoa lan vẽ ra vô cùng sống động.`,
      thumbnail: {
        mobile: wife_28_thumbnail_mobile,
        pc: wife_28_thumbnail,
      },
      detail: {
        mobile: wife_28_detail_mobile,
        pc: wife_28_detail,
      },
    },
    {
      id: 29,
      name: 'Quan Ngân Bình',
      desc: `Nữ nhi của Quan Vũ. Do là nữ nhi thứ ba của Quan Vũ nên còn được gọi là “Quan Tam Tiểu Thư”, xinh đẹp thông tuệ, võ nghệ cao cường.`,
      thumbnail: {
        mobile: wife_29_thumbnail_mobile,
        pc: wife_29_thumbnail,
      },
      detail: {
        mobile: wife_29_detail_mobile,
        pc: wife_29_detail,
      },
    },
    {
      id: 30,
      name: 'Thu Hương',
      desc: `Thân thế trắc trở, nhưng xinh đẹp dịu dàng, hiền lành chu đáo, trung can nghĩa đảm, võ công xuất sắc.`,
      thumbnail: {
        mobile: wife_30_thumbnail_mobile,
        pc: wife_30_thumbnail,
      },
      detail: {
        mobile: wife_30_detail_mobile,
        pc: wife_30_detail,
      },
    },
    {
      id: 31,
      name: 'Lữ Linh Khởi',
      desc: `Con gái Lữ Bố và Nghiêm Thị, giỏi trận pháp, do ba mẹ mất sớm nên khi ở một mình sẽ sợ cô độc`,
      thumbnail: {
        mobile: wife_31_thumbnail_mobile,
        pc: wife_31_thumbnail,
      },
      detail: {
        mobile: wife_31_detail_mobile,
        pc: wife_31_detail,
      },
    },
    {
      id: 32,
      name: 'Chân Mật',
      desc: `Người Trung Sơn Vô Cực, còn gọi là Chân Lạc hoặc Chân Mật, giỏi thi văn, có dung mạo khuynh thành, Lạc Thần Phú chính là tác phẩm Tào Thực dành cho cô.`,
      thumbnail: {
        mobile: wife_32_thumbnail_mobile,
        pc: wife_32_thumbnail,
      },
      detail: {
        mobile: wife_32_detail_mobile,
        pc: wife_32_detail,
      },
    },
    {
      id: 33,
      name: 'Mã Vân Lộc',
      desc: `Con gái của Mã Đằng, em của Mã Siêu. Từ nhỏ luyện võ, có võ công phi phàm, đàn ông bình thường khó mà địch nổi.`,
      thumbnail: {
        mobile: wife_33_thumbnail_mobile,
        pc: wife_33_thumbnail,
      },
      detail: {
        mobile: wife_33_detail_mobile,
        pc: wife_33_detail,
      },
    },
    {
      id: 34,
      name: 'Trưởng Tôn Vô Cấu',
      desc: `Nữ nhi của Hữu Kiêu Vệ Tướng Quân Trưởng Tôn Thành triều Tùy, xuất thân quý tộc, tri thư thức lễ, đoan trang hiền thục.`,
      thumbnail: {
        mobile: wife_34_thumbnail_mobile,
        pc: wife_34_thumbnail,
      },
      detail: {
        mobile: wife_34_detail_mobile,
        pc: wife_34_detail,
      },
    },
    {
      id: 35,
      name: 'Hàm Hương Công Chúa',
      desc: `Công chúc tộc Duy Ngô Nhĩ, nổi tiếng với cơ thể tỏa hương, dung mạo xinh đẹp như hoa.`,
      thumbnail: {
        mobile: wife_35_thumbnail_mobile,
        pc: wife_35_thumbnail,
      },
      detail: {
        mobile: wife_35_detail_mobile,
        pc: wife_35_detail,
      },
    },
    {
      id: 36,
      name: 'Trương Tinh Thái',
      desc: `Hậu duệ danh môn nước Thục, cao quý thoát tục, đoan trang phóng khoáng, xinh đẹp tài hoa.`,
      thumbnail: {
        mobile: wife_36_thumbnail_mobile,
        pc: wife_36_thumbnail,
      },
      detail: {
        mobile: wife_36_detail_mobile,
        pc: wife_36_detail,
      },
    },
    {
      id: 37,
      name: 'Vương Dị',
      desc: `Nữ tử thời cuối Đông Hán đến Tam Quốc, thông minh lanh lợi, hiền lành đoan trang, nổi tiếng trinh liệt.`,
      thumbnail: {
        mobile: wife_37_thumbnail_mobile,
        pc: wife_37_thumbnail,
      },
      detail: {
        mobile: wife_37_detail_mobile,
        pc: wife_37_detail,
      },
    },
    {
      id: 38,
      name: 'Lý Hương Quân',
      desc: `Lý Hương Quân từ nhỏ đã học nghệ, thông hiểu thơ nhạc, rất nhiều người ngưỡng mộ.`,
      thumbnail: {
        mobile: wife_38_thumbnail_mobile,
        pc: wife_38_thumbnail,
      },
      detail: {
        mobile: wife_38_detail_mobile,
        pc: wife_38_detail,
      },
    },
    {
      id: 39,
      name: 'Mã Tương Lan',
      desc: `Sinh ở Kim Lăng, lanh lợi, biết làm thơ vẽ tranh, sở trường vẽ lan trúc, nổi tiếng với “Tương Lan”. Tính tình rộng lượng, thường bỏ tiền giúp đỡ thiếu niên.`,
      thumbnail: {
        mobile: wife_39_thumbnail_mobile,
        pc: wife_39_thumbnail,
      },
      detail: {
        mobile: wife_39_detail_mobile,
        pc: wife_39_detail,
      },
    },
    {
      id: 40,
      name: 'Đắc Kỷ',
      desc: `Tuyệt đại yêu cơ, yêu kiều thước tha, xinh đẹp quyến rũ, mỹ nhân khuynh thành`,
      thumbnail: {
        mobile: wife_40_thumbnail_mobile,
        pc: wife_40_thumbnail,
      },
      detail: {
        mobile: wife_40_detail_mobile,
        pc: wife_40_detail,
      },
    },
    {
      id: 41,
      name: 'Thái Diễm',
      desc: `Nữ nhi của nhà văn Thái Ung Đông Hán, là nhà văn nổi tiếng của thời cuối Hán và Tam Quốc, tinh thông thiên văn toán lý, bác học, còn có tài biện luận và âm luật.`,
      thumbnail: {
        mobile: wife_41_thumbnail_mobile,
        pc: wife_41_thumbnail,
      },
      detail: {
        mobile: wife_41_detail_mobile,
        pc: wife_41_detail,
      },
    },
    {
      id: 42,
      name: 'Trương Xuân Hoa',
      desc: `Khuê các thời Tam Quốc, học thức hơn người, là một thê tử hiền đức.`,
      thumbnail: {
        mobile: wife_44_thumbnail_mobile,
        pc: wife_44_thumbnail,
      },
      detail: {
        mobile: wife_44_detail_mobile,
        pc: wife_44_detail,
      },
    },
    {
      id: 43,
      name: 'Hạ Kim Thiền',
      desc: `Hạ Hoàng Hậu người Khai Phong, trưởng nữ Hạ Cảnh Tư. Triệu Khuông Dẫn theo cha chuyển đến Khai Phong, ở Hộ Thánh Doanh, lớn lên cùng thanh mai trúc mã..`,
      thumbnail: {
        mobile: wife_45_thumbnail_mobile,
        pc: wife_45_thumbnail,
      },
      detail: {
        mobile: wife_45_detail_mobile,
        pc: wife_45_detail,
      },
    },
    {
      id: 44,
      name: 'Chúc Dung',
      desc: `Hậu duệ hỏa thần Chúc Dung, sống ở phía nam, xinh đẹp, là mỹ nhân sắc xảo!`,
      thumbnail: {
        mobile: wife_46_thumbnail_mobile,
        pc: wife_46_thumbnail,
      },
      detail: {
        mobile: wife_46_detail_mobile,
        pc: wife_46_detail,
      },
    },
    {
      id: 45,
      name: 'Mao Tường',
      desc: `Mao Tường, Lệ Cơ, nhan sắc chim sa cá lặn`,
      thumbnail: {
        mobile: wife_47_thumbnail_mobile,
        pc: wife_47_thumbnail,
      },
      detail: {
        mobile: wife_47_detail_mobile,
        pc: wife_47_detail,
      },
    },
    {
      id: 46,
      name: 'Triệu Hợp Đức',
      desc: `Muội muội Triệu Phi Yến, người tròn đầy, trắng trẻo, quyến rũ, lại đa tình dịu dàng.`,
      thumbnail: {
        mobile: wife_48_thumbnail_mobile,
        pc: wife_48_thumbnail,
      },
      detail: {
        mobile: wife_48_detail_mobile,
        pc: wife_48_detail,
      },
    },
    {
      id: 47,
      name: 'Bình Dương Công Chúa',
      desc: `Bình Dương Công Chúa, trưởng nữ của Hán Cảnh Đế Lưu Khởi và hoàng hậu Vương Chí. Thời Vũ Đế là một nhân vật chính trị quan trọng, sau gả cho Vệ Thanh.`,
      thumbnail: {
        mobile: wife_53_thumbnail_mobile,
        pc: wife_53_thumbnail,
      },
      detail: {
        mobile: wife_53_detail_mobile,
        pc: wife_53_detail,
      },
    },
    {
      id: 48,
      name: 'Hoa Mộc Lan',
      desc: `Hoa Mộc Lan nữ cải nam trang, thay cha tòng quân, chinh chiến sa trường 12 năm, lập nhiều chiến công, trở về nhà quay về thân phận nữ nhi chăm sóc cha mẹ. Câu chuyện về Hoa Mộc Lan được《Mộc Lan Từ》truyền tụng đến nay.`,
      thumbnail: {
        mobile: wife_56_thumbnail_mobile,
        pc: wife_56_thumbnail,
      },
      detail: {
        mobile: wife_56_detail_mobile,
        pc: wife_56_detail,
      },
    },
  ],
  HERO: [
    {
      id: 1,
      name: 'Linh Linh Phát',
      desc: `Một trong tứ đại cao thủ trong hoàng cung, phụ trách bảo vệ hoàng đế. Thích phát minh, có đầu óc, dùng tuyệt kỹ Thiên Ngoại Phi Tiên.`,
      thumbnail: {
        mobile: hero_1_thumbnail_mobile,
        pc: hero_1_thumbnail,
      },
      detail: {
        mobile: hero_1_detail_mobile,
        pc: hero_1_detail,
      },
    },
    {
      id: 2,
      name: 'Ngao Bái',
      desc: `Xuất thân gia đình tướng lĩnh, tinh thông thuật cưỡi ngựa bắn cung. Theo Hoàng Thái Cực chinh chiến, lập nhiều công lao, rất được tín nhiệm, được tôn xưng là "Đệ Nhất Dũng Sĩ Mãn Châu".`,
      thumbnail: {
        mobile: hero_2_thumbnail_mobile,
        pc: hero_2_thumbnail,
      },
      detail: {
        mobile: hero_2_detail_mobile,
        pc: hero_2_detail,
      },
    },
    {
      id: 3,
      name: 'Hòa Thân',
      desc: `Họ Nữu Cổ Lộc, tên Thiện Bảo, tự là Chí Trai, chủ nhân của Gia Lạc Đường, Thập Hốt Viên, Lục Dã Đình. Người huyện Khai Nguyên, phủ Phụng Thiên, thuộc Chính Hồng Kỳ Mãn Châu, quyền thần nhà Thanh.`,
      thumbnail: {
        mobile: hero_3_thumbnail_mobile,
        pc: hero_3_thumbnail,
      },
      detail: {
        mobile: hero_3_detail_mobile,
        pc: hero_3_detail,
      },
    },
    {
      id: 4,
      name: 'Trịnh Bản Kiều',
      desc: `Cả đời chỉ vẽ lan, tre, đá, tự xưng là "Lan bốn mùa không tàn, tre quanh năm xanh biếc, đá ngàn đời bất diệt, người mãi vẹn lòng son". Ông là một nhà văn, họa sĩ tiêu biểu của thời đại nhà Thanh, các tác phẩm thơ văn, thư pháp, tranh vẽ của ông được người đời xưng tụng là "Tam Tuyệt".`,
      thumbnail: {
        mobile: hero_4_thumbnail_mobile,
        pc: hero_4_thumbnail,
      },
      detail: {
        mobile: hero_4_detail_mobile,
        pc: hero_4_detail,
      },
      speechBox: box_tuong_than_1,
    },
    {
      id: 5,
      name: 'Hỉ Lai Lạc',
      desc: `Có y thuật vượt trội, tính lương thiện thẳng thắn, quyết không luồn cúi, đồng thời cũng nổi tiếng sợ vợ. Tuy thích Tái Tây Thi, nhưng vẫn rất chung thủy với vợ mình.`,
      thumbnail: {
        mobile: hero_5_thumbnail_mobile,
        pc: hero_5_thumbnail,
      },
      detail: {
        mobile: hero_5_detail_mobile,
        pc: hero_5_detail,
      },
    },
    {
      id: 6,
      name: 'Tô Khất Nhi',
      desc: `Tô Xán, con của Quảng Châu Tướng Quân, gia tài đồ sộ, võ nghệ cao cường nhưng lại mù chữ, công tử phá gia vung tiền như rác. Về sau gặp được Như Sương, bị trúng tiếng sét ái tình. Sau nhiều trắc trở, trở thành Bang Chủ Cái Bang, học được Hàng Long Thập Bát Chưởng.`,
      thumbnail: {
        mobile: hero_6_thumbnail_mobile,
        pc: hero_6_thumbnail,
      },
      detail: {
        mobile: hero_6_detail_mobile,
        pc: hero_6_detail,
      },
    },
    {
      id: 7,
      name: 'Lý Vệ',
      desc: `Tự là Hữu Giai, hiệu Cáp Đình, người Giang Nam. Rất được hoàng đế Ung Chính xem trọng. Ông là vị quan thanh liêm, không e sợ quyền quý, dù giữ chức vụ nào cũng biết yêu dân như con, được bá tánh quý mến.`,
      thumbnail: {
        mobile: hero_7_thumbnail_mobile,
        pc: hero_7_thumbnail,
      },
      detail: {
        mobile: hero_7_detail_mobile,
        pc: hero_7_detail,
      },
    },
    {
      id: 8,
      name: 'Lưu Bá Ôn',
      desc: `Tự là Bá Ôn, tinh thông thiên văn, binh pháp, số học, đặc biệt nổi tiếng với tài thơ văn. Thơ văn của ông mang nét thanh tao cổ điển mà lại hùng vĩ phóng khoáng, không ít tác phẩm trong số đó mang đề tài đả kích hủ bại, đau xót dân tình. Ông và Tống Liêm, Cao Khởi được gọi chung là "Tam đại văn hào thời Minh sơ".`,
      thumbnail: {
        mobile: hero_8_thumbnail_mobile,
        pc: hero_8_thumbnail,
      },
      detail: {
        mobile: hero_8_detail_mobile,
        pc: hero_8_detail,
      },
      speechBox: box_tuong_than_2,
    },
    {
      id: 9,
      name: 'Lâm Tắc Từ',
      desc: `Tự là Nguyên Phủ, lại có tự là Thiếu Mục, Thạch Lân, về già hiệu là Sĩ Thôn Lão Nhân, Bình Tuyền Cư Sĩ, Lịch Xã Tản Nhân. Người huyện Hầu Quân, tỉnh Phúc Kiến, nhà chính trị, nhà văn, nhà tư tưởng cuối thời nhà Thanh.`,
      thumbnail: {
        mobile: hero_9_thumbnail_mobile,
        pc: hero_9_thumbnail,
      },
      detail: {
        mobile: hero_9_detail_mobile,
        pc: hero_9_detail,
      },
    },
    {
      id: 10,
      name: 'Phương Thế Ngọc',
      desc: `Đứng thứ hai trong số Thiếu Lâm Thập Hổ, tính cương trực, dữ dội, tinh thông võ nghệ, sức khỏe vô địch, thân hình đồ sộ, cơ bắp cuồn cuộn, chuyên lo chuyện bất bình.`,
      thumbnail: {
        mobile: hero_10_thumbnail_mobile,
        pc: hero_10_thumbnail,
      },
      detail: {
        mobile: hero_10_detail_mobile,
        pc: hero_10_detail,
      },
    },
    {
      id: 11,
      name: 'Đa Nhĩ Cổn',
      desc: `Con thứ mười bốn của Thanh Thái Tổ Nỗ Nhĩ Cáp Xích, con thứ hai của vương phi A Ba Hợi. Nhà chính trị, nhà quân sự kiệt xuất đầu đời nhà Thanh.`,
      thumbnail: {
        mobile: hero_11_thumbnail_mobile,
        pc: hero_11_thumbnail,
      },
      detail: {
        mobile: hero_11_detail_mobile,
        pc: hero_11_detail,
      },
    },
    {
      id: 12,
      name: 'Tả Tông Đường',
      desc: `Tự là Quý Cao, lại có tự là Phác Tồn, hiệu Tương Thượng Nông Nhân, người huyện Tương Âm, tỉnh Hồ Nam. Nhà chính trị, nhà quân sự nổi tiếng cuối thời Thanh, ủng hộ dẫn nhập thành tựu tiến bộ phương tây. Ông cùng Tăng Quốc Phiên và hai người khác được gọi chung là "Tứ đại danh thần trung hưng cuối thời Thanh".`,
      thumbnail: {
        mobile: hero_12_thumbnail_mobile,
        pc: hero_12_thumbnail,
      },
      detail: {
        mobile: hero_12_detail_mobile,
        pc: hero_12_detail,
      },
    },
    {
      id: 13,
      name: 'Trương Chi Động',
      desc: `Tự là Hiếu Đạt, hiệu Hương Đào. Do ông giữ chức Tổng Đốc, xưng là "Soái", nên được người đương thời gọi là "Trương Hương Soái". Danh thần cuối thời Thanh, nhân vật tiêu biểu trong phong trào học tập phương tây. Chức quan cao nhất là Nhân Các Đại Học Sĩ.`,
      thumbnail: {
        mobile: hero_13_thumbnail_mobile,
        pc: hero_13_thumbnail,
      },
      detail: {
        mobile: hero_13_detail_mobile,
        pc: hero_13_detail,
      },
    },
    {
      id: 14,
      name: 'Bồ Tùng Linh',
      desc: `Tự là Lưu Tiên, lại có tự là Kiếm Thần, biệt hiệu Liễu Tuyền Cư Sĩ, người đời gọi là Liêu Trai Tiên Sinh, tự xưng là Dị Sử Thị (tức người kể dã sử), người Tri Châu, phủ Tế Nam. Nhà văn kiệt xuất thời Thanh, có nhiều tác phẩm tiểu thuyết ngắn ưu tú.`,
      thumbnail: {
        mobile: hero_14_thumbnail_mobile,
        pc: hero_14_thumbnail,
      },
      detail: {
        mobile: hero_14_detail_mobile,
        pc: hero_14_detail,
      },
    },
    {
      id: 15,
      name: 'Lý Hồng Chương',
      desc: `Vốn tên là Lý Chương Đồng, tự là Tiệm Phố, Tử Phất, hiệu là Thiếu Thuyên, về già tự hiệu là Nghi Tẩu, biệt hiệu Tỉnh Tâm, người huyện Hợp Phì, tỉnh An Huy. Nhà chính trị, nhà ngoại giao, tướng lĩnh quân sự nổi tiếng cuối thời Thanh. Người đời hay gọi ông là "Lý Trung Đường", "Lý Phụ Tướng".`,
      thumbnail: {
        mobile: hero_15_thumbnail_mobile,
        pc: hero_15_thumbnail,
      },
      detail: {
        mobile: hero_15_detail_mobile,
        pc: hero_15_detail,
      },
    },
    {
      id: 16,
      name: 'Lý Tầm Hoan',
      desc: `Lý Tầm Hoan, từng thi được Thám Hoa, nên còn gọi là Tiểu Lý Thám Hoa, về sau do không hứng thú với công danh nên từ quan ở ẩn; Tiểu Lý Phi Đao, Binh Khí Phổ xếp hạng 3.`,
      thumbnail: {
        mobile: hero_16_thumbnail_mobile,
        pc: hero_16_thumbnail,
      },
      detail: {
        mobile: hero_16_detail_mobile,
        pc: hero_16_detail,
      },
    },
    {
      id: 17,
      name: 'Sách Ni',
      desc: `Sách Ni, thuộc Hách Xá Lý Thị, người Chính Hoàng Kỳ Mãn Châu. Ông là một trong các khai quốc công thần của nhà Thanh, từng liên hợp với ba người khác đảm nhiệm chức vị Phụ Chính Đại Thần.`,
      thumbnail: {
        mobile: hero_17_thumbnail_mobile,
        pc: hero_17_thumbnail,
      },
      detail: {
        mobile: hero_17_detail_mobile,
        pc: hero_17_detail,
      },
    },
    {
      id: 18,
      name: 'Hồ Tuyết Nham',
      desc: `Hồ Tuyết Nham, tên thật Hồ Quang Dung, tự Tuyết Nham, sinh ra ở An Huy. Thương nhân nổi tiếng thời cận đại, nhà chính sự, người đại diện. Hồ Tuyết Nham dựa vào tài năng thương nghiệp xuất sắc, dùng quan ngân qua tay mở tiền trang tư nhân ở Thượng Hải, về sau lập nhiều phân hiệu tiền trang Phụ Khang khắp cả nước, được gọi là Thần Tài Sống. Ở Hàng Châu lập tiệm thuốc đông y Hồ Khánh Dư Đường, tiệm thuốc truyền đến nay được xưng là Giang Nam Dược Vương.`,
      thumbnail: {
        mobile: hero_18_thumbnail_mobile,
        pc: hero_18_thumbnail,
      },
      detail: {
        mobile: hero_18_detail_mobile,
        pc: hero_18_detail,
      },
    },
    {
      id: 19,
      name: 'Tào Tuyết Cần',
      desc: `Vốn tên là Tào Thiêm, tự là Mộng Nguyễn, hiệu là Tuyết Cần, lại có hiệu là Cần Khê, Cần Phố. Ông bỏ ra rất nhiều thời gian và tâm huyết, trải qua nhiều trắc trở, cuối cùng viết thành "Hồng Lâu Mộng", một tác phẩm vĩ đại, mang đậm nét tư tưởng và nghệ thuật đương thời.`,
      thumbnail: {
        mobile: hero_19_thumbnail_mobile,
        pc: hero_19_thumbnail,
      },
      detail: {
        mobile: hero_19_detail_mobile,
        pc: hero_19_detail,
      },
    },
    {
      id: 20,
      name: 'Hải Đại Phú',
      desc: `Cao thủ đại nội, một lòng muốn báo thù cho hoàng đế Đồng Trị. Để đối phó với kẻ địch hiểm ác, sẵn lòng mạo hiểm, liều đánh đổi sức khỏe để luyện thành thần công "Hóa Cốt Miên Chưởng".`,
      thumbnail: {
        mobile: hero_20_thumbnail_mobile,
        pc: hero_20_thumbnail,
      },
      detail: {
        mobile: hero_20_detail_mobile,
        pc: hero_20_detail,
      },
    },
    {
      id: 21,
      name: 'Hoa Đà',
      desc: `Hoa Đà, tự Nguyên Hóa, tinh thông y thuật, là một thầy thuốc nổi tiếng thời cuối Đông Hán và đầu thời Tam Quốc. Ông được xưng tụng như một Thần y nổi tiếng.`,
      thumbnail: {
        mobile: hero_21_thumbnail_mobile,
        pc: hero_21_thumbnail,
      },
      detail: {
        mobile: hero_21_detail_mobile,
        pc: hero_21_detail,
      },
    },
    {
      id: 22,
      name: 'Mặc Tử',
      desc: `Mặc Tử, tên Địch, người nước Tống thời cuối Xuân Thu Chiến Quốc. Ông là người sáng lập phái Mặc Gia, cũng là nhà tư tưởng, giáo dục, khoa học, quân sự nổi tiếng thời Chiến Quốc. Lúc đó còn được gọi là Phi Nho Tức Mặc. Đệ tử ghi chép cuộc đời của Mặc Tử tổng hợp thành quyển sách Mặc Tử.`,
      thumbnail: {
        mobile: hero_22_thumbnail_mobile,
        pc: hero_22_thumbnail,
      },
      detail: {
        mobile: hero_22_detail_mobile,
        pc: hero_22_detail,
      },
    },
    {
      id: 23,
      name: 'Đỗ Phủ',
      desc: `Tự là Tử Mỹ, tự hiệu là Thiếu Lăng Dã Lão, nhà thơ hiện thực vĩ đại của thời Đường. Ông sinh ra tại huyện Củng, tỉnh Hà Nam, nguyên quán Tương Dương, tỉnh Hồ Bắc. Do thời Đường có hai cặp văn nhân cùng được gọi chung là "Lý Đỗ", Lý Bạch và Đỗ Phủ được gọi là "Đại Lý Đỗ" để phân biệt với "Tiểu Lý Đỗ" là Lý Thương Ẩn và Đỗ Mục.`,
      thumbnail: {
        mobile: hero_23_thumbnail_mobile,
        pc: hero_23_thumbnail,
      },
      detail: {
        mobile: hero_23_detail_mobile,
        pc: hero_23_detail,
      },
    },
    {
      id: 24,
      name: 'Liêm Pha',
      desc: `Liêm Pha, danh tướng nước Triệu thời Chiến Quốc, cùng với Bạch Khởi. Vương Tiễn và Lý Mục được gọi là "Tứ đại danh tướng Chiến Quốc". Vào thời Đường Đức Tông đã thờ 64 vị võ tướng kiệt xuất khác bao gồm Liêm Pha trong Miếu Võ Thành Vương, được gọi là Miếu Võ Thành Vương 64 Tướng. Thời Tống Huy Tông truy phong Liêm Pha làm Lâm Thành Bá, là một trong 72 vị tướng trong Miếu Tống Võ.`,
      thumbnail: {
        mobile: hero_24_thumbnail_mobile,
        pc: hero_24_thumbnail,
      },
      detail: {
        mobile: hero_24_detail_mobile,
        pc: hero_24_detail,
      },
    },
    {
      id: 25,
      name: 'Trang Chu',
      desc: `Trang Tử, tự Tý Hưu, người Mông nước Tống. Nhà tư tưởng, triết học và văn học nổi tiếng thời Đông Chu Chiến Quốc. Sáng lập phái Trang Học là triết học quan trọng của Hoa Hạ, kế thừa Lão Tử là người đại diện phái Đạo Gia thời Chiến Quốc, nhân vật đại diện của phái Đạo Gia. Tác phẩm tiêu biểu gồm Trang Tử, trong đó có Tiêu Dao Du, Tề Vật Luận.`,
      thumbnail: {
        mobile: hero_25_thumbnail_mobile,
        pc: hero_25_thumbnail,
      },
      detail: {
        mobile: hero_25_detail_mobile,
        pc: hero_25_detail,
      },
    },
    {
      id: 26,
      name: 'Lý Nguyên Phương',
      desc: `Lý Nguyên Phương, sống ở Lương Châu. Lý Nguyên Phương là đội trưởng của Địch Nhân Kiệt, trợ thủ đắc lực của Địch Nhân Kiệt. Tính tình bốc lửa, làm việc chăm chỉ, nguyên tắc mạnh. Võ công cao cường và can đảm hơn người. Tuy võ công cao nhưng không thô lỗ, đặc biệt khi Địch Nhân Kiệt không ở bên cạnh thể hiện năng lực phán đoán mạnh mẽ.`,
      thumbnail: {
        mobile: hero_26_thumbnail_mobile,
        pc: hero_26_thumbnail,
      },
      detail: {
        mobile: hero_26_detail_mobile,
        pc: hero_26_detail,
      },
    },
    {
      id: 27,
      name: 'Lỗ Ban',
      desc: `Lỗ Ban, người nước Lỗ thời Xuân Thu, người được gọi là Công Du Bàn, Công Du Ban, Ban Du, gọi chung là Công Du Tử, còn gọi là Lỗ Ban. Tên gọi Lỗ Ban dành cho người lao động thời cổ đại gọi tượng trưng cho trí tuệ.`,
      thumbnail: {
        mobile: hero_27_thumbnail_mobile,
        pc: hero_27_thumbnail,
      },
      detail: {
        mobile: hero_27_detail_mobile,
        pc: hero_27_detail,
      },
    },
    {
      id: 28,
      name: 'Tôn Vũ',
      desc: `Tôn Vũ, tự Trường Khanh, người nước Tề thời Xuân Thu. Nhà quân sự, chính sự nổi tiếng thời Xuân Thu, còn gọi là Binh Thánh hoặc Tôn Tử, Binh Gia Chí Thánh. Tác phẩm lớn Tôn Tử Binh Pháp, sau được nhà binh pháp yêu thích, xưng là Binh Học Thánh Điển, đứng đầu Võ Kinh Thất Thư.`,
      thumbnail: {
        mobile: hero_28_thumbnail_mobile,
        pc: hero_28_thumbnail,
      },
      detail: {
        mobile: hero_28_detail_mobile,
        pc: hero_28_detail,
      },
    },
    {
      id: 29,
      name: 'Trương Lương',
      desc: `Trương Lương, tự Tự Phòng, là mưu sĩ, đại thần kiệt xuất thời cuối nhà Tần đầu nhà Hán, cùng Hoàng Phi Hồng, Tiêu Hà Bính xưng là Hán Tam Kiệt. Tinh thông đạo hoàng lão, không ham quyền quý, cuối đời cùng Xích Tùng Tử vân du. Trương Lương qua đời được sắc phong Văn Thành Hầu. Sử Ký-Lưu Hầu Thế Gia ghi chép cuộc đời của Trương Lương.`,
      thumbnail: {
        mobile: hero_29_thumbnail_mobile,
        pc: hero_29_thumbnail,
      },
      detail: {
        mobile: hero_29_detail_mobile,
        pc: hero_29_detail,
      },
    },
    {
      id: 30,
      name: 'Khương Tử Nha',
      desc: `Khương Tử Nha, tự Tử Nha, biệt hiệu Phi Hùng, người thời Chu Thương. Do tổ tiên có công hỗ trợ bình thủy nên sắc phong họ Lữ, còn gọi là Lữ Thượng. Khương Tử Nha hỗ trợ Võ Vương lập ra nhà Chu, người lập ra nước Tề, thống soái quân sự cấp cao và khai quốc nguyên thần của Tây Chu, người sáng lập văn hóa nhà Tề. Được gọi là Bách Gia Tông Sư.`,
      thumbnail: {
        mobile: hero_30_thumbnail_mobile,
        pc: hero_30_thumbnail,
      },
      detail: {
        mobile: hero_30_detail_mobile,
        pc: hero_30_detail,
      },
    },
    {
      id: 31,
      name: 'Tôn Tẫn',
      desc: `Tôn Tẫn, tên thật là  là nhà quân sự thời Chiến Quốc, là hậu duệ của Tôn Vũ. Vào thời Đường Đức Tông đã thờ 64 vị võ tướng kiệt xuất khác bao gồm Tôn Tẫn trong Miếu Võ Thành Vương, được gọi là Miếu Võ Thành Vương 64 Tướng. Thời Tống Huy Tông truy phong Tôn Tẫn làm Võ Thanh Bá, là một trong 72 vị tướng trong Miếu Tống Võ.`,
      thumbnail: {
        mobile: hero_31_thumbnail_mobile,
        pc: hero_31_thumbnail,
      },
      detail: {
        mobile: hero_31_detail_mobile,
        pc: hero_31_detail,
      },
    },
    {
      id: 32,
      name: 'Bạch Khởi',
      desc: `Bạch Khởi, người nước Tần thời Chiến Quốc. Hậu duệ Bạch Công Thắng nước Sở. Nhà quân sự thời Chiến Quốc, danh tướng nước Tần, nhân vật đại diện Binh Gia. Bạch Khởi là nhà quân sự kiệt xuất sau Tôn Vũ và Ngô Khởi, Thiên Tự Văn giúp ông ấy cùng Liêm Pha, Lý Mục, Vương Tiễn được xưng là tứ đại danh tướng Chiến Quốc.`,
      thumbnail: {
        mobile: hero_32_thumbnail_mobile,
        pc: hero_32_thumbnail,
      },
      detail: {
        mobile: hero_32_detail_mobile,
        pc: hero_32_detail,
      },
    },
    {
      id: 33,
      name: 'Quan Vũ',
      desc: `Quan Vũ, tự Vân Trường, đứng đầu trong Ngũ Hổ Thượng Tướng, nổi tiếng với điển tích Trà Ấm Trảm Hoa Hùng, Quá Ngũ Quan Trảm Lục Tướng. Ông là người trung nghĩa, anh dũng nên được thiên hạ tôn làm Võ Thánh`,
      thumbnail: {
        mobile: hero_33_thumbnail_mobile,
        pc: hero_33_thumbnail,
      },
      detail: {
        mobile: hero_33_detail_mobile,
        pc: hero_33_detail,
      },
    },
    {
      id: 34,
      name: 'Trương Phi',
      desc: `Trương Phi, một trong Ngũ Hổ Thượng Tướng của Thục Hán, dũng mãnh vô song. Trương Phi kết nghĩa vườn đào với Lưu Bị và Quan Vũ`,
      thumbnail: {
        mobile: hero_34_thumbnail_mobile,
        pc: hero_34_thumbnail,
      },
      detail: {
        mobile: hero_34_detail_mobile,
        pc: hero_34_detail,
      },
    },
    {
      id: 35,
      name: 'Triệu Vân',
      desc: `Triệu Vân, tự là Tử Long, người vùng Thường Sơn, một trong Ngũ Hổ Thượng Tướng của Thục Hán, Ông chính là vị tướng làm nên kỳ tích một mình cứu chúa trong trận Trường Bản`,
      thumbnail: {
        mobile: hero_35_thumbnail_mobile,
        pc: hero_35_thumbnail,
      },
      detail: {
        mobile: hero_35_detail_mobile,
        pc: hero_35_detail,
      },
    },
    {
      id: 36,
      name: 'Mã Siêu',
      desc: `Mã Siêu, tự Mạnh Khởi, một trong Ngũ Hổ Thượng Tướng của Thục Hán, tác chiến vô cùng dũng mãnh, từng nhiều lần đánh bại quân Tào`,
      thumbnail: {
        mobile: hero_36_thumbnail_mobile,
        pc: hero_36_thumbnail,
      },
      detail: {
        mobile: hero_36_detail_mobile,
        pc: hero_36_detail,
      },
    },
    {
      id: 37,
      name: 'Hoàng Trung',
      desc: `Hoàng Trung, tự Hán Thăng, một trong Ngũ Hổ Thượng Tướng, tuy đã già nhưng sức khỏe và tài năng chẳng thua kém ai, từng trảm Hạ Hầu Uyên thuộc hạ của Tào Tháo ở trận Định Quân Sơn. Trước khi "đầu quân" cho nhà Thục của Lưu Bị, ông theo Lưu Biểu`,
      thumbnail: {
        mobile: hero_37_thumbnail_mobile,
        pc: hero_37_thumbnail,
      },
      detail: {
        mobile: hero_37_detail_mobile,
        pc: hero_37_detail,
      },
    },
    {
      id: 38,
      name: 'Gia Cát Lượng',
      desc: `Gia Cát Lượng, tự Khổng Minh, hiệu Ngọa Long tiên sinh, quân sư kiệt xuất của nước Thục, giúp Lưu Bị cùng với Tôn Quyền đánh bại Tào Tháo ở Xích Bích, lấy Kinh Châu, định Tây Xuyên, dựng nước ở đất Thục`,
      thumbnail: {
        mobile: hero_38_thumbnail_mobile,
        pc: hero_38_thumbnail,
      },
      detail: {
        mobile: hero_38_detail_mobile,
        pc: hero_38_detail,
      },
    },
    {
      id: 39,
      name: 'Bàng Thống',
      desc: `Bàng Thống, tự Sĩ Nguyên, ông là mưu sĩ dưới trướng Lưu Bị thời Tam Quốc, giữ chức quan Quân Sư Trung Lang Tướng, tài trí sánh ngang với Gia Cát Lượng, được mọi người tôn là "Phượng Sồ".`,
      thumbnail: {
        mobile: hero_39_thumbnail_mobile,
        pc: hero_39_thumbnail,
      },
      detail: {
        mobile: hero_39_detail_mobile,
        pc: hero_39_detail,
      },
    },
    {
      id: 40,
      name: 'Chu Du',
      desc: `Chu Du, tên tự Công Cẩn, đương thời gọi Chu Lang, là danh tướng và khai quốc công thần của nước Đông Ngô. Chu Du nổi tiếng với chiến thắng ở Trận Xích Bích trước quân Tào Tháo`,
      thumbnail: {
        mobile: hero_40_thumbnail_mobile,
        pc: hero_40_thumbnail,
      },
      detail: {
        mobile: hero_40_detail_mobile,
        pc: hero_40_detail,
      },
    },
    {
      id: 41,
      name: 'Quách Gia',
      desc: `Quách Gia, tự Phụng Hiếu, người Dĩnh Xuyên Dương Địch, giữ chức quan Quân Sư Tế Tửu, qua đời khi còn trẻ. Có bài thơ như sau: "Lương kế hoàn hoàn bất di sách, mỗi lâm chế biến mãn tọa kinh."`,
      thumbnail: {
        mobile: hero_41_thumbnail_mobile,
        pc: hero_41_thumbnail,
      },
      detail: {
        mobile: hero_41_detail_mobile,
        pc: hero_41_detail,
      },
    },
    {
      id: 42,
      name: 'Hung Nô Vương',
      desc: `Hung Nô Vương, còn được gọi là Chiến Thần sau khi đăng cơ trở thành vua của nước Hung Nô. Nước Hung Nô thời A Đề Lạp là chương cuối cùng của lịch sử Hung Nô, cũng là chương chói lọi nhất. Ông ấy khiến tất cả kẻ địch đều phải khiếp sợ, ông ấy và Thiết Kỵ Hung Nô đều được gọi là Roi Thượng Đế.`,
      thumbnail: {
        mobile: hero_42_thumbnail_mobile,
        pc: hero_42_thumbnail,
      },
      detail: {
        mobile: hero_42_detail_mobile,
        pc: hero_42_detail,
      },
    },
    {
      id: 43,
      name: 'Kinh Kha',
      desc: `Họ Khương, thuộc Khánh thị, tự là Thứ Phi, người nước Vệ, thích khách nổi tiếng cuối thời Chiến Quốc. Ông là hậu duệ của Đại Phu Khánh Phong nước Tề thời Xuân Thu Chiến Quốc, do đó cũng được gọi là Khánh Khanh, Kinh Khanh, Khánh Kha.`,
      thumbnail: {
        mobile: hero_43_thumbnail_mobile,
        pc: hero_43_thumbnail,
      },
      detail: {
        mobile: hero_43_detail_mobile,
        pc: hero_43_detail,
      },
    },
    {
      id: 44,
      name: 'Vi Tiểu Bảo',
      desc: `Vốn là người Dương Châu. Vô tình vào cung gặp và quen với hoàng đế Khang Hi. Về sau tham gia bắt Ngao Bái, gia nhập Thiên Địa Hội, bái sư Tổng Đà Chủ Trần Cận Nam. Đến Ngũ Đài Sơn, xuất gia để bảo vệ hoàng đế Thuận Trị. Sau này lại được lệnh đi sứ ban hôn, đại phá Thần Long Đảo, trợ giúp công chúa Nga đoạt ngôi, công lao hiển hách.`,
      thumbnail: {
        mobile: hero_44_thumbnail_mobile,
        pc: hero_44_thumbnail,
      },
      detail: {
        mobile: hero_44_detail_mobile,
        pc: hero_44_detail,
      },
    },
    {
      id: 45,
      name: 'Hoàng Phi Hồng',
      desc: `Hoàng Phi Hồng, người Hoài Âm, Tây Hán khai quốc công thần, nhà quân sự kiệt xuất trong lịch sử, cùng Tiêu Hà, Trương Lương được gọi là Hán Tam Kiệt, cùng Bành Việt, Anh Bố xưng là Hán Tam Đại Danh Tướng. Hoàng Phi Hồng được gọi là Quốc Sĩ Vô Song, người đời sau tôn làm Binh Tiên, Chiến Thần. Vương Hầu Tướng Tương đều do Hoàng Phi Hồng một mình đảm nhận.`,
      thumbnail: {
        mobile: hero_45_thumbnail_mobile,
        pc: hero_45_thumbnail,
      },
      detail: {
        mobile: hero_45_detail_mobile,
        pc: hero_45_detail,
      },
    },
    {
      id: 46,
      name: 'Lý Bạch',
      desc: `Tự là Thái Bạch, hiệu Thanh Liên Cư Sĩ, lại có hiệu là "Trích Tiên Nhân", nhà thơ lãng mạn vĩ đại thời Đường. Ông được người đời sau xưng tụng là "Thi Tiên", gọi chung với Đỗ Phủ là "Đại Lý Đỗ", phân biệt với "Tiểu Lý Đỗ" là Lý Thương Ẩn và Đỗ Mục.`,
      thumbnail: {
        mobile: hero_46_thumbnail_mobile,
        pc: hero_46_thumbnail,
      },
      detail: {
        mobile: hero_46_detail_mobile,
        pc: hero_46_detail,
      },
    },
    {
      id: 47,
      name: 'Lữ Bố',
      desc: `Tự là Phụng Tiên, người huyện Cửu Nguyên, quận Ngũ Nguyên. Một trong các anh hùng cát cứ cuối thời Hán.`,
      thumbnail: {
        mobile: hero_47_thumbnail_mobile,
        pc: hero_47_thumbnail,
      },
      detail: {
        mobile: hero_47_detail_mobile,
        pc: hero_47_detail,
      },
    },
    {
      id: 48,
      name: 'Tôn Sách',
      desc: `Tôn Sách, tự Bá Phù, người Ngô . Con trai cả của Tôn Kiên, huynh trưởng của Tôn Quyền. vào cuối thời Đông Hán, ông từng chiếm giữ vùng Giang Đông, là một trong những anh hùng cuối nhà Hán, là người tạo dựng nước Ngô trong thời kỳ Tam Quốc.`,
      thumbnail: {
        mobile: hero_48_thumbnail_mobile,
        pc: hero_48_thumbnail,
      },
      detail: {
        mobile: hero_48_detail_mobile,
        pc: hero_48_detail,
      },
    },
    {
      id: 49,
      name: 'Hán Vũ Đế',
      desc: `Lưu Triệt, tức Hán Vũ Đế, hoàng đế thứ 7 của Tây Hán, nhà chính sự, chiến lược. Hán Vũ Đế có công lao ở các lĩnh vực, nhưng sau khi lên ngôi rất hiếu chiến lại dùng vu cổ, vì thế để lại ảnh hưởng.`,
      thumbnail: {
        mobile: hero_49_thumbnail_mobile,
        pc: hero_49_thumbnail,
      },
      detail: {
        mobile: hero_49_detail_mobile,
        pc: hero_49_detail,
      },
    },
    {
      id: 50,
      name: 'Tôn Thượng Hương',
      desc: `Tôn phu nhân, em gái Tôn Quyền. Lưu Bị định Kinh Châu, Tôn Quyền cho em gái liên hôn, kết mối giao hảo. Tôn phu nhân tài giỏi mạnh mẽ, có phong thái của đại ca. Sau được lập miếu thờ là Kiêu Cơ Miếu.`,
      thumbnail: {
        mobile: hero_50_thumbnail_mobile,
        pc: hero_50_thumbnail,
      },
      detail: {
        mobile: hero_50_detail_mobile,
        pc: hero_50_detail,
      },
    },
    {
      id: 51,
      name: 'Quan Ngân Bình',
      desc: `Quan Ngân Bình, người huyện Giải, con gái của Quan Vũ. Do người đứng hàng thứ ba trong bốn người con của Quan Vũ nên còn được gọi là "Quan Tam Tiểu Thư" hoặc "Quan Vũ Tam Tiểu Thư". Tương truyền người là đệ tử của Triệu Vân, cùng Gia Cát Lượng bình định Di Tộc.`,
      thumbnail: {
        mobile: hero_51_thumbnail_mobile,
        pc: hero_51_thumbnail,
      },
      detail: {
        mobile: hero_51_detail_mobile,
        pc: hero_51_detail,
      },
    },
    {
      id: 52,
      name: 'Đường Bá Hổ',
      desc: `Tự là Bá Hổ, nhũ danh là Tử Vị, hiệu là Lục Như Cư Sĩ, người huyện Ngô, phủ Tô Châu, nguyên quán quận Tấn Xương, Lương Châu. Ông là họa sĩ, nhà thư pháp, nhà thơ nổi tiếng thời Minh.`,
      thumbnail: {
        mobile: hero_52_thumbnail_mobile,
        pc: hero_52_thumbnail,
      },
      detail: {
        mobile: hero_52_detail_mobile,
        pc: hero_52_detail,
      },
    },
    {
      id: 53,
      name: 'Lữ Linh Khởi',
      desc: `Lữ Linh Khởi, con gái Lữ Bố và Nghiêm Thị. Do Lữ Bố bại dưới tay Lý Thôi phải trốn khỏi Trường An để lại đứa con gái ở đó, sau được Bàng Thư hộ tống đưa về lại cho Lữ Bố. Tuy từng được đề nghị hôn nhân chính trị với Viên Thuật, nhưng trên đường  đã bị đưa về lại. Khi Lữ Bố ở Hạ Phì bị Tào Tháo bao vây, việc thông gia được nhắc lại nhưng bị Tào Tháo và Lưu Bị ngăn cản.`,
      thumbnail: {
        mobile: hero_53_thumbnail_mobile,
        pc: hero_53_thumbnail,
      },
      detail: {
        mobile: hero_53_detail_mobile,
        pc: hero_53_detail,
      },
    },
    {
      id: 54,
      name: 'Tào Phi',
      desc: `Tào Phi, tự Tử Hoàn, nhà văn hóa nổi tiếng thời Tam Quốc, hoàng đế khai quốc của Tào Ngụy. Người ở huyện Tiêu nước Bái, trưởng tử của Ngụy Vũ Đế Tào Tháo và Vũ Tuyên Biện Hoàng Hậu. Sau khi qua đời có miếu hiệu là Cao Tổ, thụy hiệu là Văn Hoàng Đế, chôn ở Thủ Dương Lăng.`,
      thumbnail: {
        mobile: hero_54_thumbnail_mobile,
        pc: hero_54_thumbnail,
      },
      detail: {
        mobile: hero_54_detail_mobile,
        pc: hero_54_detail,
      },
    },
    {
      id: 55,
      name: 'Mã Vân Lộc',
      desc: `Mã Vân Lộc, con gái Mã Đằng, thê tử Triệu Vân, muội muội Mã Siêu. Tính tình ngây thơ thẳng thắn, am hiểu thương thuật.`,
      thumbnail: {
        mobile: hero_55_thumbnail_mobile,
        pc: hero_55_thumbnail,
      },
      detail: {
        mobile: hero_55_detail_mobile,
        pc: hero_55_detail,
      },
    },
    {
      id: 56,
      name: 'Lý Thế Dân',
      desc: `Lý Thế Dân, tức Đường Thái Tông, là con thứ của Lý Uyên và Đậu Hoàng Hậu, vị hoàng đế thứ 2 của triều Đường, nhà chính sự, chiến lược, quân sự, nhà thơ kiệt xuất. Lý Thế Dân yêu thích văn học và thư pháp, có nhiều tác phẩm quý giá truyền thế.`,
      thumbnail: {
        mobile: hero_56_thumbnail_mobile,
        pc: hero_56_thumbnail,
      },
      detail: {
        mobile: hero_56_detail_mobile,
        pc: hero_56_detail,
      },
    },
    {
      id: 57,
      name: 'Nhĩ Đan Vương Tử',
      desc: `Nhĩ Đan là người yêu của Hàm Hương, Nhĩ Đan yêu Hàm Hương từ khi còn nhỏ, tuy hai người từng cùng nhau bỏ trốn bảy lần nhưng do mùi thơm độc đáo trên người Hàm Hương nên chưa lần nào thành công. Cuối cùng Nhĩ Đan và Hàm Hương cũng được nên duyên với nhau.`,
      thumbnail: {
        mobile: hero_57_thumbnail_mobile,
        pc: hero_57_thumbnail,
      },
      detail: {
        mobile: hero_57_detail_mobile,
        pc: hero_57_detail,
      },
    },
    {
      id: 58,
      name: 'Trương Tinh Thái',
      desc: `Trương Tinh Thái, con gái Trương Phi và Hạ Hầu Thị, vợ Lưu Thiền, sử sách gọi là Hoàng Hậu.`,
      thumbnail: {
        mobile: hero_58_thumbnail_mobile,
        pc: hero_58_thumbnail,
      },
      detail: {
        mobile: hero_58_detail_mobile,
        pc: hero_58_detail,
      },
    },
    {
      id: 59,
      name: 'Trương Liêu',
      desc: `Trương Liêu, tự là Văn Viễn, một trong Ngũ Hổ Tướng của Tào Ngụy, từng tham gia nhiều trận đánh lớn và nổi tiếng nhất qua trận Hợp Phì với quân Đông Ngô`,
      thumbnail: {
        mobile: hero_59_thumbnail_mobile,
        pc: hero_59_thumbnail,
      },
      detail: {
        mobile: hero_59_detail_mobile,
        pc: hero_59_detail,
      },
    },
    {
      id: 60,
      name: 'Nhạc Tiến',
      desc: `Nhạc Tiến, tự Văn Khiêm, là một võ tướng dưới quyền Tào Tháo cuối thời Đông Hán. Ông được miêu tả là có phần thấp bé nhưng rất dũng mãnh trên chiến trường. Nhạc Tiến góp công lớn trong chiến dịch của Tào Tháo chống lại Lữ Bố, Lưu Bị, tàn dư quân Hoàng Cân và chiến dịch đánh Viên Thiệu.`,
      thumbnail: {
        mobile: hero_60_thumbnail_mobile,
        pc: hero_60_thumbnail,
      },
      detail: {
        mobile: hero_60_detail_mobile,
        pc: hero_60_detail,
      },
    },
    {
      id: 61,
      name: 'Vu Cấm',
      desc: `Vu Cấm, tự Văn Tắc, là một võ tướng cuối thời Đông Hán, thuộc hạ của Tào Tháo, đã chinh chiến rất nhiều chiến dịch cho Tào Tháo, tạo dựng nên nền tảng nước Ngụy.`,
      thumbnail: {
        mobile: hero_61_thumbnail_mobile,
        pc: hero_61_thumbnail,
      },
      detail: {
        mobile: hero_61_detail_mobile,
        pc: hero_61_detail,
      },
    },
    {
      id: 62,
      name: 'Trương Hợp',
      desc: `Trương Hợp, tự Tuấn Nghệ. Thời Đông Hán mạt, tham gia Hoàng Cân khởi nghĩa, sau theo Dực Châu Mục Hàn Phúc làm Quân Tư Mã. Tào Phi xưng đế, được thăng làm tướng quân, phong Mạc Hầu, theo Tào Chân an định Khương Hồ, cùng Hạ Hầu Thượng vây Giang Lăng. Trương Hợp một đời chinh chiến, dùng binh linh hoạt, giỏi trận doanh, biết lợi dụng địa hình.`,
      thumbnail: {
        mobile: hero_62_thumbnail_mobile,
        pc: hero_62_thumbnail,
      },
      detail: {
        mobile: hero_62_detail_mobile,
        pc: hero_62_detail,
      },
    },
    {
      id: 63,
      name: 'Từ Hoảng',
      desc: `Từ Hoảng, tự Công Minh, là vị tướng được đánh giá là xuất sắc nhất của triều đình Tào Ngụy. Trong sự nghiệp của mình, ông lập được vô số chiến công, nổi bật nhất là việc đánh thắng Quan Vũ trong trận chiến Phàn Thành.`,
      thumbnail: {
        mobile: hero_63_thumbnail_mobile,
        pc: hero_63_thumbnail,
      },
      detail: {
        mobile: hero_63_detail_mobile,
        pc: hero_63_detail,
      },
    },
    {
      id: 64,
      name: 'Mô Kim Hiệu Úy',
      desc: `Chức quan thời xưa, được Tào Tháo lập ra, chính là chủ nhiệm phòng đạo mộ quốc gia. Thời cổ chuyên đào mộ lấy tài sản làm quân hưởng, sau dùng để chỉ người trộm mộ.`,
      thumbnail: {
        mobile: hero_64_thumbnail_mobile,
        pc: hero_64_thumbnail,
      },
      detail: {
        mobile: hero_64_detail_mobile,
        pc: hero_64_detail,
      },
    },
    {
      id: 65,
      name: 'Vương Dị',
      desc: `Vương Dị, vợ của Thứ Sử Ích Châu Triệu Ngang, mẹ của Triệu Anh, Triệu Nguyệt. Từng giúp chồng ngăn địch, lập nhiều công lao, góp nhiều kế sách, một lòng trung thành không tiếc bản thân.`,
      thumbnail: {
        mobile: hero_65_thumbnail_mobile,
        pc: hero_65_thumbnail,
      },
      detail: {
        mobile: hero_65_detail_mobile,
        pc: hero_65_detail,
      },
    },
    {
      id: 66,
      name: 'Trương Xuân Hoa',
      desc: `Cô gái thời Tam Quốc, cương nghị quả quyết, có khí thế nam tử hán.`,
      thumbnail: {
        mobile: hero_66_thumbnail_mobile,
        pc: hero_66_thumbnail,
      },
      detail: {
        mobile: hero_66_detail_mobile,
        pc: hero_66_detail,
      },
    },
    {
      id: 67,
      name: 'Triệu Khuông Dẫn',
      desc: `Người sáng lập ra Đại Tống, xuất thân quân nhân, con thứ Triệu Hồng Ân. Triệu Khuông Dẫn tại vị, làm theo sách lược của tể tướng Triệu Phổ Tiên Nam Hậu Bắc, Dễ Trước Khó Sau, hết lòng thống nhất đất nước, diệt Kinh Nam, Hậu Thục, Nam Hán, Nam Đường, hoàn thành thống nhất gần như cả nước.`,
      thumbnail: {
        mobile: hero_67_thumbnail_mobile,
        pc: hero_67_thumbnail,
      },
      detail: {
        mobile: hero_67_detail_mobile,
        pc: hero_67_detail,
      },
    },
    {
      id: 68,
      name: 'Chúc Dung',
      desc: `Vợ của Di tộc Đại Vương Mãnh Hoạch, hậu duệ Hỏa Thần Chúc Dung, võ nghệ cao cường, giỏi phi đao. Từng đánh bại và bắt sống tướng Thục Trương Nghi khi Khổng Minh nam chinh thảo phạt.`,
      thumbnail: {
        mobile: hero_68_thumbnail_mobile,
        pc: hero_68_thumbnail,
      },
      detail: {
        mobile: hero_68_detail_mobile,
        pc: hero_68_detail,
      },
    },
    {
      id: 69,
      name: 'Cao Trường Cung',
      desc: `Một trong tứ đại mỹ nam thời cổ xưa, tương truyền dung mạo tuấn tú, vì vậy mỗi khi ra trận đều đeo mặt nạ ác quỷ để thêm phần uy nghi.`,
      thumbnail: {
        mobile: hero_69_thumbnail_mobile,
        pc: hero_69_thumbnail,
      },
      detail: {
        mobile: hero_69_detail_mobile,
        pc: hero_69_detail,
      },
    },
    {
      id: 70,
      name: 'Dương Diên Chiêu',
      desc: `Tướng kháng Liêu, người Liêu cho rằng khắc tinh của họ là sao thứ 6 trong Bắc Đẩu Thất Tinh, nên đã xem ông ta như Lục Lang Tinh Tục hạ phàm, gọi là Dương Lục Lang.`,
      thumbnail: {
        mobile: hero_70_thumbnail_mobile,
        pc: hero_70_thumbnail,
      },
      detail: {
        mobile: hero_70_detail_mobile,
        pc: hero_70_detail,
      },
    },
    {
      id: 71,
      name: 'Hoắc Khứ Bệnh',
      desc: `Giỏi cưỡi ngựa bắn cung, dụng binh linh hoạt chú trọng sách lược, 17 tuổi lần đầu chinh chiến, thống lĩnh 800 phiêu kỵ đã đuổi được quân Hung Nô. Ở trận Mạc Bắc, được phong Lang Cư Tế, chiến thắng trở về.`,
      thumbnail: {
        mobile: hero_71_thumbnail_mobile,
        pc: hero_71_thumbnail,
      },
      detail: {
        mobile: hero_71_detail_mobile,
        pc: hero_71_detail,
      },
    },
    {
      id: 72,
      name: 'Lục Tốn',
      desc: `Nổi tiếng khi đại bại quân Thục Hán của Lưu Bị ở trận Di Lăng. Suy nghĩ sâu xa, trung thành chính trực, cả đời chinh chiến, được phong làm Xã Tắc Chi Thần.`,
      thumbnail: {
        mobile: hero_72_thumbnail_mobile,
        pc: hero_72_thumbnail,
      },
      detail: {
        mobile: hero_72_detail_mobile,
        pc: hero_72_detail,
      },
    },
    {
      id: 73,
      name: 'Chân-Lữ Bố',
      desc: `Tam Quốc Đệ Nhất Mãnh Tướng, danh xưng Mã Trung Xích Thố, Nhân Trung Lữ Bố, chiến Tam Anh, diệt Đổng Trác, hộ Điêu Thuyền, từng là chiến thần trong thời đại đó.`,
      thumbnail: {
        mobile: hero_75_thumbnail_mobile,
        pc: hero_75_thumbnail,
      },
      detail: {
        mobile: hero_75_detail_mobile,
        pc: hero_75_detail,
      },
    },
    {
      id: 74,
      name: 'Tư Mã Ý',
      desc: `Ngọa Long Phượng Sồ Chủng Hổ, Tư Mã Ý nhiều tuổi nhất sống lâu nhất trở thành người chiến thắng cuối cùng. Chủng Hổ là hổ mai phục ở phần mộ, âm hiểm và hung hãn, ra tay lấy mạng. Để chiến thắng, hắn luôn nhẫn nhịn, chỉ cần kẻ thù đều vong mạng thì thiên hạ sẽ là của Chủng Hổ, cuối cùng thiên hạ đều về tay nhà Tư Mã.`,
      thumbnail: {
        mobile: hero_77_thumbnail_mobile,
        pc: hero_77_thumbnail,
      },
      detail: {
        mobile: hero_77_detail_mobile,
        pc: hero_77_detail,
      },
    },
    {
      id: 75,
      name: 'Vệ Thanh',
      desc: `Vệ Thanh, vốn họ Trịnh, dùng họ mẹ là Vệ, tự Trọng Khanh. Năm 129 TCN, có công đánh Hung Nô, Hán Vũ Đế phong Vệ Thanh làm Đại Tướng Quân, thống soái lục sư.`,
      thumbnail: {
        mobile: hero_79_thumbnail_mobile,
        pc: hero_79_thumbnail,
      },
      detail: {
        mobile: hero_79_detail_mobile,
        pc: hero_79_detail,
      },
    },
    {
      id: 76,
      name: 'Hoa Mộc Lan',
      desc: `Hoa Mộc Lan nữ cải nam trang, thay cha tòng quân, chinh chiến sa trường 12 năm, lập nhiều chiến công, trở về nhà quay về thân phận nữ nhi chăm sóc cha mẹ. Câu chuyện về Hoa Mộc Lan được《Mộc Lan Từ》truyền tụng đến nay.`,
      thumbnail: {
        mobile: hero_82_thumbnail_mobile,
        pc: hero_82_thumbnail,
      },
      detail: {
        mobile: hero_82_detail_mobile,
        pc: hero_82_detail,
      },
    },
  ],
};

export default CharacterData;